import { useState, useEffect, useMemo } from "react"
import { Link, useParams, useLocation, useNavigate } from "react-router-dom"
import Select from "react-select";
import PersonalInfoModal from "./Components/PatientPersonalModal"
import AddressModal from "./Components/PatientAddressModal"
import TransactionHistory from "./Components/TranscationHistory.jsx"
import { getPatientDetailsAction, fetchFamilyTreeListAction, getPatientsAction } from "../../../../store/actions/PatientsAction"
import { getReportsAction, sendReportLinkAction, editReportAction, deleteReportAction } from "../../../../store/actions/ReportAction"
import { getDiseasesAction } from "../../../../store/actions/DiseasesAction"
import { getPatientCuredDiseasesAction, updatePatientCuredDiseasesAction } from "../../../../store/actions/PatientCuredDiseasesAction"
import WeightChart from "./Components/WeightChart"
import { useDispatch, useSelector } from "react-redux"
import { Tab, Nav, Button, Modal, FormControl, InputGroup, Dropdown } from "react-bootstrap"

import "chart.js/auto"
import Swal from "sweetalert2"
import FullCalendar from "@fullcalendar/react"
import dayGridPlugin from "@fullcalendar/daygrid"
import timeGridPlugin from "@fullcalendar/timegrid"
import interactionPlugin from "@fullcalendar/interaction"
import { NotesHistory } from "./Components/NotesHistory.jsx"
// Import the actions for fetching important questions
import { fetchAnswers } from "../../../../store/actions/QuestionnaireActions"
import { getImportantQuestionsAction } from "../../../../store/actions/ImportantQuestionAction"
import { getDoctorsAction } from "../../../../store/actions/DoctorsAction";
//Images
import flag from "../../../../../src/images/profile/icons8-flag-100.png"
import { FaWhatsapp } from "react-icons/fa";
import defaultAvatar from "../../../../../src/assets/images/placeholder.jpg"
import icon from "../../../../../src/assets/images/icons8-chart-48.png"
import icon3 from "../../../../../src/assets/images/medical-report.png"
import { PatientNotes } from "./Components/Notes.components"
import DiseaseHistory from "./Components/DiseaseHistory"
import PatientPrescription from "./Components/Prescription.Component"
import ImportantQuestion from "./Components/ImportentQuestion.Component"
import MenopauseChart from "./Components/PatientMenopause.Component"
import PatientGapld from "./Components/PatientGapld.Component.jsx"
import PatientMale from "./Components/PatientMalechart.Component"
import Loader from "../../Common/Loader.jsx"
import { handleSuccess, showErrorAlert } from "../../../../services/ErrorHandlingService.js"
import FamilyTree from "./Components/FamilyTree.jsx"
import { formatDate } from "../../../../utils/dateUtils.js"
import { FaAddressCard, FaQrcode } from "react-icons/fa";
import { MdQrCode } from "react-icons/md";
import EditReportForm from "./Components/EditReportForm.jsx";
import axiosInstance from "../../../../services/AxiosInstance.js"; // Assuming axiosInstance is configured for your API
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { getObjections } from "../../../../services/ObjectionService";
import { getPatientObjectionsService, updatePatientObjectionsService } from "../../../../services/PatientObjectionService";
import UploadReportButton from "../../Common/UploadReportButton.jsx";
const initialEvents = [
  {
    title: "Booked",
    start: new Date("2025-02-15 10:00:00"),
    end: new Date("2025-02-15 11::00"),
    classNames: ["bg-red"],
  },
  {
    title: "Booked",
    start: new Date("2025-02-18 11::00"),
    end: new Date("2025-02-18 12:00"),
    classNames: ["bg-red"],
  },
  {
    title: "Booked",
    start: new Date("2025-01-20 12::00"),
    end: new Date("2025-01-20 13:00"),
    classNames: ["bg-red"],
  },
]
const staticFollowUps = [
  {
    date: "2025-01-12",
    time: "11:00 AM",
    disease: "Diabetes",
    doctor_name: "Dr. Mehta",
  },
  {
    date: "2025-02-20",
    time: "02:00 PM",
    disease: "Thyroid",
    doctor_name: "Dr. Sharma",
  },
  {
    date: "2025-03-05",
    time: "05:30 PM",
    disease: "Back Pain",
    doctor_name: "Dr. Kulkarni",
  },
];

const testImages = [
  "https://picsum.photos/400/300?random=1",
  "https://picsum.photos/400/300?random=2",
  "https://picsum.photos/400/300?random=3"
];

const PatientsDetails = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { patientId } = useParams()
  const location = useLocation()
  const patientData = location.state?.patientData
  const patientDetails = useSelector((state) => state.patients?.patientDetails)

  const patients = useSelector((state) => state.patients.patients || [])

  // Add state for important questions
  const [importantQuestionsLoading, setImportantQuestionsLoading] = useState(false)
  const importantQuestions = useSelector((state) => state.importantQuestions?.importantQuestions || [])
  const familyTreeList = useSelector((state) => state.patients?.familyTreeList || [])
  const [dragStartX, setDragStartX] = useState(null);
  const [isDragging, setIsDragging] = useState(false);

  const [isLoading, setIsLoading] = useState(false)
  const [duration, setDuration] = useState(null)
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false)
  const [hovered, setHovered] = useState(null)
  const [isPersonalModalOpen, setIsPersonalModalOpen] = useState(false)
  const [isDiseaseModalOpen, setIsDiseaseModalOpen] = useState(false)
  const [selectedImage, setSelectedImage] = useState(null)
  const [imagePreview, setImagePreview] = useState(null)
  const [isFileInputDisabled, setIsFileInputDisabled] = useState(false)
  const [weight, setWeight] = useState("")
  const [height, setHeight] = useState("")
  const [bmi, setBmi] = useState("")
  const [systolicBP, setSystolicBP] = useState("")
  const [diastolicBP, setDiastolicBP] = useState("")
  const [pulseRate, setPulseRate] = useState("")
  const [temperature, setTemperature] = useState("")
  const [oxygenSaturation, setOxygenSaturation] = useState("")
  const [bloodGlucose, setBloodGlucose] = useState("")
  const [allergies, setAllergies] = useState("")
  const [reports, setReports] = useState(null)
  const [uploadedFiles, setUploadedFiles] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [showPersonalInfo, setShowPersonalInfo] = useState(false);
  const [showActionModal, setShowActionModal] = useState(false);

  //gapld
  const [show, setShow] = useState(false)
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [noteDescription, setNoteDescription] = useState("")
  const [calendarEvents, setCalendarEvents] = useState(initialEvents)
  // preview report 
  const [previewGallery, setPreviewGallery] = useState([]);
  const [previewIndex, setPreviewIndex] = useState(0);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  // notes modal
  const [noteType, setNoteType] = useState("self")
  const [selectedRole, setSelectedRole] = useState(null)
  const [selectedRoles, setSelectedRoles] = useState([])
  const [activeNote, setActiveNote] = useState(null)
  const [showMessageBox, setShowMessageBox] = useState(false)
  const [messages, setMessages] = useState([])
  const [newMessage, setNewMessage] = useState("")
  const [searchTerm, setSearchTerm] = useState("")
  const [isPersonalInfoModalOpen, setIsPersonalInfoModalOpen] = useState(false)
  const [isAddressModalOpen, setIsAddressModalOpen] = useState(false)
  const [isOtherInfoModalOpen, setIsOtherInfoModalOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const [activeKey, setActiveKey] = useState("noteshistory");
  // Reports related states
  const [sendingReportLink, setSendingReportLink] = useState(false)
  const [loadingReports, setLoadingReports] = useState(false)

  const [spouseName, setSpouseName] = useState("-");
  // weight
  const [showChart, setShowChart] = useState(false)
  const [patientName, setPatientName] = useState("")
  const [followUpAppointments, setFollowUpAppointments] = useState([]);
  const [medicineDetails, setMedicineDetails] = useState({
    medicineName: "",
    medicineDose: "",
    frequency: "",
    weightOfDose: "",
    timePerDay: "",
    rateOfMedicine: "",
    anupaan: "",
  })
  const [lastNotes, setLastNotes] = useState("")
  const [selectedDiseases, setSelectedDiseases] = useState([])
  const [showRow, setShowRow] = useState(false)
  const [referrals, setReferrals] = useState([]);
  const [referenceCount, setReferenceCount] = useState(0);
  const [formData, setFormData] = useState({
    patient_id: "",
    diseases: [],
    name: "",
    name1: "",
    Contact: "",
    email: "",
    profileImage1: "",
    branch: "",
    additionalContact: "",
    dob: "",
    height: "",
    weight: "",
    occupation: "",
    idNumber: "",
    gender: "",
    spouseName: "",
    idProof: "",
    //Address details
    tempAddressLine1: "",
    tempAddressLine2: "",
    tempArea: "",
    tempCity: "",
    tempState: "",
    tempCountry: "",
    tempPincode: "",
    permAddressLine1: "",
    permAddressLine2: "",
    permArea: "",
    permCity: "",
    permState: "",
    permPincode: "",
    permCountry: "",
    //personal
    //Gapld
    abortionDate: "",
    deliveryOption: "",
    rxHelp: "",
    deliveryDetails: "",
    miscarriageDetails: "",
    miscarriageReason: "",
    // personal info
    marriageInfo: [],
    marriageHistory: "",
    marriageDate: "",
    disease_names: [],
    currentDisease: [],
    diseaseStatus: "",
    spouseName1: "",
    age: 32,
    spouseOption: "",
    dateOfBirth: "",
    deliveryDate: "",
    medicineName: "",
    dose: "",
    frequency: "",
    quantity: "",
    howToTake: "",
    // Other info
    adName: "",
    adSet: "",
    campaignName: "",
    leadSource: "",
    status: "",
    priority: "",
    modifiedBy: "",
    userType: "",
    treatmentHistory: "",
    treatment_completed: "No",
    referred_by_manual: "",
    reviewProvided: false,
    testimonialProvided: false,
    admin_review_approval: "Pending",
    admin_testimonial_approval: "Pending",
    review_by_role_id: null,
    testimonial_by_role_id: null,
  })
  const [selectedCurationDiseases, setSelectedCurationDiseases] = useState([]);
  // report doctor file
  const [selectedDoctorId, setSelectedDoctorId] = useState("");
  const [doctorError, setDoctorError] = useState("");
  const [updatingCuredDiseases, setUpdatingCuredDiseases] = useState(false);
  const userDetails = JSON.parse(localStorage.getItem("userDetails")) || {};
  const roleName = userDetails?.role_name || "";

  const isDoctor = userDetails.role_name === "Doctor";

  const [showDiseaseModal, setShowDiseaseModal] = useState(false);
  const [selectDiseases, setSelectDiseases] = useState([]);
  // Fetch diseases from Redux store
  const diseaseList = useSelector((state) => state.diseases?.diseases || []);
  // Fetch cured diseases from Redux store
  const curedDiseases = useSelector((state) => state.patientCuredDiseases?.curedDiseases || []);

  // Helper function to get disease names from disease IDs
  const getCuredDiseaseNames = (diseaseIds) => {
    if (!diseaseIds || diseaseIds.length === 0) return [];
    if (!diseaseList || diseaseList.length === 0) return [];

    // Deduplicate disease IDs before processing
    const uniqueIds = [...new Set(diseaseIds.map(id => Number(id)))];

    return uniqueIds
      .map((id) => {
        const disease = diseaseList.find(
          (d) => d.disease_id === id || Number(d.disease_id) === id
        );
        return disease ? disease.disease_name : null;
      })
      .filter(Boolean);
  };

  const [weightChartData, setWeightChartData] = useState(null)
  const [latestWeightData, setLatestWeightData] = useState(null)
  const [shouldHideWeightSection, setShouldHideWeightSection] = useState(false)
  const [showEditModal, setShowEditModal] = useState(false);
  const [editReport, setEditReport] = useState(null);
  // for patient treatment complete
  const [isTreatmentComplete, setIsTreatmentComplete] = useState(false);
  const [updatingTreatmentStatus, setUpdatingTreatmentStatus] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(false);
  const [selectedObjection, setSelectedObjection] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);

  const [finalCurationDiseases, setFinalCurationDiseases] = useState([]);

  const [showObjectionModal, setShowObjectionModal] = useState(false);
  const [searchObjection, setSearchObjection] = useState("");
  const [objections, setObjections] = useState([]);
  const [objectionsLoading, setObjectionsLoading] = useState(false);
  const [objectionsError, setObjectionsError] = useState(null);
  const [selectedPatientObjections, setSelectedPatientObjections] = useState([]);
  const [patientObjectionsLoading, setPatientObjectionsLoading] = useState(false);
  const [updatingPatientObjections, setUpdatingPatientObjections] = useState(false);
  const [followUps, setFollowUps] = useState([]);
  const [sendingLink, setSendingLink] = useState(false);
  const objectionOptions = objections.map((obj) => ({
    value: obj.objection_text || obj.text,
    label: obj.objection_text || obj.text,
  }));

  const filteredObjectionList = objections.filter((obj) =>
    (obj.objection_text || obj.text).toLowerCase().includes(searchObjection.toLowerCase())
  );

  // Fetch objections from API
  useEffect(() => {
    const fetchObjectionsData = async () => {
      try {
        setObjectionsLoading(true);
        setObjectionsError(null);
        const response = await getObjections(
          10, // pagination
          1, // pageid
          "", // search_by
          "", // search_keyword
          "", // sort_by
          "" // sort_order
        );

        if (response?.data?.data) {
          const objectionList = Array.isArray(response.data.data)
            ? response.data.data
            : [response.data.data];
          setObjections(objectionList);
        }
      } catch (error) {
        console.error("Error fetching objections:", error);
        setObjectionsError(error.message);
      } finally {
        setObjectionsLoading(false);
      }
    };

    fetchObjectionsData();
  }, []);

  // Fetch patient objections
  useEffect(() => {
    const fetchPatientObjections = async () => {
      if (!patientId) return;
      try {
        setPatientObjectionsLoading(true);
        const response = await getPatientObjectionsService(patientId);

        if (response?.data?.data) {
          const patientObjList = Array.isArray(response.data.data)
            ? response.data.data
            : [response.data.data];
          setSelectedPatientObjections(patientObjList);
        }
      } catch (error) {
        console.error("Error fetching patient objections:", error);
      } finally {
        setPatientObjectionsLoading(false);
      }
    };

    fetchPatientObjections();
  }, [patientId]);

  const handleSelectObjection = (item) => {
    const objectionText = item.objection_text || item.text;
    setSelectedObjection(objectionText);

    setFormData((prev) => ({
      ...prev,
      objection: objectionText,
    }));

    setOpenDropdown(false);
    setShowObjectionModal(false);
  };

  const handleDeleteReport = async (report) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) return;

    try {
      await dispatch(deleteReportAction(report.report_id));

      // Success alert
      // await Swal.fire({
      //   title: "Deleted!",
      //   text: "Report has been deleted successfully.",
      //   icon: "success",
      //   timer: 1500,
      //   showConfirmButton: false,
      // });

      // Refresh list
      dispatch(getReportsAction(patientId));

    } catch (error) {
      // Swal.fire({
      //   title: "Error!",
      //   text: "Failed to delete report.",
      //   icon: "error",
      // });
    }
  };

  // const handleEditReport = (report) => {
  //   setEditReport(report);

  //   setFormData({
  //     reportTitle: report.report_title,
  //     reportdescription: report.report_description,
  //     reportDate: report.report_date,
  //   });

  //   // setIsEditMode(true);
  //   setShowEditModal(true);
  // };

  const handleEditReport = (report) => {
    setEditReport(report);
    setShowEditModal(true);
  };
  // Handle patient objection checkbox change
  const handlePatientObjectionChange = async (objection) => {
    try {
      setUpdatingPatientObjections(true);

      const objectionId = objection.objection_id || objection.id;
      let updatedObjections;

      // Check if this objection is already selected
      const isSelected = selectedPatientObjections.some(
        (obj) => (obj.objection_id || obj.id) === objectionId
      );

      if (isSelected) {
        // Remove objection
        updatedObjections = selectedPatientObjections.filter(
          (obj) => (obj.objection_id || obj.id) !== objectionId
        );
      } else {
        // Add objection
        updatedObjections = [...selectedPatientObjections, objection];
      }

      // Extract objection IDs for API call
      const objectionIds = updatedObjections.map((obj) => obj.objection_id || obj.id);

      // Call API to update patient objections
      const response = await updatePatientObjectionsService(patientId, objectionIds);

      // If response is successful (200 status code), update local state
      if (response) {
        setSelectedPatientObjections(updatedObjections);
        handleSuccess("Objection updated successfully");
      }
    } catch (error) {
      console.error("Error updating patient objections:", error);
      showErrorAlert(error.response?.data?.message || "Failed to update objection");
    } finally {
      setUpdatingPatientObjections(false);
    }
  };


  const handleTreatmentStatusChange = async (e) => {
    const newStatus = e.target.checked;
    const patientId = formData.patient_id;

    if (!patientId) {
      showErrorAlert("Patient ID is missing");
      return;
    }

    try {
      setUpdatingTreatmentStatus(true);

      const apiFormData = new FormData();
      apiFormData.append("patient_id", patientId);
      apiFormData.append("treatment_completed", newStatus ? "Yes" : "No");

      const response = await axiosInstance.post(
        "/admin/updateTreatmentStatus",
        apiFormData
      );

      // ✅ FIXED SUCCESS CHECK
      if (response?.data?.status === true) {

        setFormData(prev => ({
          ...prev,
          treatment_completed: newStatus ? "Yes" : "No",
        }));

        handleSuccess(response?.data?.message || "Updated successfully");

        // If treatment is marked as completed, call the cured diseases API
        if (newStatus && formData.diseases && formData.diseases.length > 0) {
          // Get disease IDs from formData.diseases
          const diseaseIds = formData.diseases.map(disease => 
            typeof disease === 'object' ? disease.disease_id : disease
          ).filter(id => id);
          
          if (diseaseIds.length > 0) {
            dispatch(updatePatientCuredDiseasesAction(patientId, diseaseIds));
          }
        }

        dispatch(getPatientDetailsAction(patientId));

      } else {
        throw new Error(response?.data?.message || "Failed to update");
      }

    } catch (error) {

      console.error("Error updating treatment status:", error);

      showErrorAlert(
        error?.response?.data?.message ||
        error.message ||
        "Something went wrong"
      );

    } finally {
      setUpdatingTreatmentStatus(false);
    }
  };



  const fetchAllAppointments = async (patientId) => {
    try {
      const response = await axiosInstance.post(
        "/patient/AllappointmentList",
        {
          patient_id: patientId,
        }
      );

      if (response.data?.status === "success") {
        const data = response.data.data;

        // API returns object → convert to array
        const formattedData = Array.isArray(data) ? data : [data];

        setFollowUpAppointments(formattedData);
      }

    } catch (error) {
      console.error("Failed to fetch appointments:", error);
    }
  };
  const downloadVCF = () => {
    if (!formData?.name || !formData?.Contact) {
      showErrorAlert("Contact info not available");
      return;
    }

    const fullName = formData.name.trim();
    const nameParts = fullName.split(" ");
    const firstName = nameParts[0] || "";
    const lastName = nameParts.slice(1).join(" ") || "";

    const vcf = [
      "BEGIN:VCARD",
      "VERSION:3.0",
      `N:${lastName};${firstName};;;`,
      `FN:${fullName}`,
      `TEL;TYPE=CELL:${formData.Contact}`,
      formData.email ? `EMAIL:${formData.email}` : "",
      "END:VCARD"
    ]
      .filter(Boolean) // removes empty lines
      .join("\n");

    //    const blob = new Blob([vcf], { type: "text/vcard;charset=utf-8" });
    const blob = new Blob([vcf], { type: "text/x-vcard;charset=utf-8" });

    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = `${fullName.replace(/\s+/g, "_")}.vcf`;
    link.click();

    URL.revokeObjectURL(url);
  };

  const doctors = useSelector((state) => state.doctors.doctors || []);

  const formatOptionLabel = ({ label, specialization }) => (
    <div>
      <div style={{ fontWeight: "bold" }}>{label}</div>
      <div style={{ fontSize: "0.8em", color: "#666" }}>{specialization}</div>
    </div>
  );
  const selectedDoctor = doctors.find(
    (doc) => doc.doctor_id === selectedDoctorId
  );

  // const selectedDoctorValue = selectedDoctor
  //   ? {
  //       value: selectedDoctor.doctor_id,
  //       label: selectedDoctor.doctor_name,
  //       specialization: selectedDoctor.specialization,
  //     }
  //   : null;
  const selectedDoctorValue = doctors
    .map(d => ({
      value: String(d.doctor_id),
      label: d.doctor_name,
      specialization: d.specialization || "-"
    }))
    .find(opt => opt.value === String(selectedDoctorId)) || null;

  useEffect(() => {
    if (isDoctor && doctors.length > 0 && userDetails?.admin_username) {
      const matchedDoctor = doctors.find(
        d => d.doctor_username === userDetails.admin_username
      );

      if (matchedDoctor) {
        setSelectedRecipient("doctor");
        setSelectedDoctorId(String(matchedDoctor.doctor_id));
      } else {
        console.warn("Doctor not found in doctors list for logged-in user");
      }
    }
  }, [isDoctor, doctors, userDetails?.admin_username]);


  useEffect(() => {
    dispatch(getDoctorsAction());
  }, [dispatch]);

  // Fetch diseases for successful disease curation modal
  useEffect(() => {
    dispatch(getDiseasesAction());
  }, [dispatch]);

  // Fetch patient's cured diseases
  useEffect(() => {
    if (patientId) {
      dispatch(getPatientCuredDiseasesAction(patientId));
    }
  }, [dispatch, patientId]);
  useEffect(() => {

    if (patientId) {
      fetchAllAppointments(patientId);
    }

  }, [patientId]);
  // Initialize finalCurationDiseases when curedDiseases are loaded
  useEffect(() => {
    if (curedDiseases && curedDiseases.length > 0) {
      // Deduplicate and normalize to numbers
      const uniqueDiseases = [...new Set(curedDiseases.map((id) => (!isNaN(id) ? Number(id) : id)))];
      setFinalCurationDiseases(uniqueDiseases);
    } else {
      setFinalCurationDiseases([]);
    }
  }, [curedDiseases]);

  // Fetch important questions data
  useEffect(() => {
    const fetchImportantQuestions = async () => {
      try {
        if (patientId) {
          setImportantQuestionsLoading(true)
          await dispatch(
            fetchAnswers({
              patient_id: patientId,
              is_important: "No",
            }),
          )
          await dispatch(getImportantQuestionsAction(patientId, "No"))
        }
      } catch (err) {
        const msg = err?.message || "Error fetching questions."
        showErrorAlert(msg)
      } finally {
        setImportantQuestionsLoading(false)
      }
    }
    fetchImportantQuestions()
  }, [dispatch, patientId])

  useEffect(() => {
    if (patientId) {
      dispatch(getPatientDetailsAction(patientId));
    }
  }, [dispatch, patientId]);

  // 2. Fetch patient list once details ready
  useEffect(() => {
    if (patientDetails && (!patients || patients.length === 0)) {
      dispatch(getPatientsAction(false));
    }
  }, [dispatch, patientDetails, patients]);

  // Process important questions to get tab groups
  const getTabGroups = () => {
    // Filter only groups with make_as_tab === "Yes"
    const tabGroups = importantQuestions.filter(
      (question) => question.make_as_tab === "Yes" && question.isGroup === "Yes",
    )

    // Group questions by group_id
    const groupsData = importantQuestions.reduce((groups, question) => {
      // Skip if the question doesn't have a group_id
      if (!question.group_id) return groups

      const groupId = question.group_id
      if (!groups[groupId]) {
        // Find the group info from tabGroups
        const groupInfo = tabGroups.find((g) => g.group_id === groupId) || {}
        groups[groupId] = {
          group_id: groupId,
          group_name: question.group_name || groupInfo.group_name || "Untitled Group",
          make_as_tab: question.make_as_tab || groupInfo.make_as_tab || "No",
          questions: [],
        }
      }

      // Only add the question if it's not a group itself
      if (question.isGroup !== "Yes") {
        groups[groupId].questions.push(question)
      }
      return groups
    }, {})

    // Convert object to array and filter only tabs
    return Object.values(groupsData).filter(
      (group) => group.make_as_tab === "Yes" && group.questions && group.questions.length > 0,
    )
  }

  const tabGroupsArray = getTabGroups()

  useEffect(() => {
    if (patientId) {
      setIsLoading(true)
      // Fetch both patient details and reports
      Promise.all([dispatch(getPatientDetailsAction(patientId)), dispatch(getReportsAction(patientId))])
        .then(() => { })
        .catch((error) => {
          showErrorAlert("Failed to load patient data: " + error.message)
        })
        .finally(() => {
          setIsLoading(false)
        })
    } else {
      console.warn("No patient ID found in URL.")
      showErrorAlert("No patient ID provided")
    }
  }, [dispatch, patientId])

  useEffect(() => {
    if (patientDetails) {
      const {
        patient_id,
        first_name,
        middile_name,
        last_name,
        whatsapp_contact_no,
        patient_email,
        patient_photo,
        branch,
        additional_contact_no,
        date_of_birth,
        height,
        weight,
        occupation,
        id_proof,
        id_number,
        gender,
        husband_or_spouse_name,
        age,
        marriage_history,
        marriage_date,
        diseases = [],
        current_disease_id,
        spouse_option,
        marriageInfo,
        TemporaryAddress,
        PermanentAddress,
        OtherInfo,
        treatment_completed,
        referredBy,
        disease_percentage,
        intensity_of_treatment,
        referred_by,
        telecaller_name,
        referrals = [],
        referred_by_manual,
        review_provided,
testimonial_provided,
      } = patientDetails
      setReferrals(referrals)
      setReferenceCount(referrals.length)
      const diseaseIds = diseases?.map((d) => d.disease_id.toString()) || []

      let diseaseStatus = ""
      if (current_disease_id && diseases && Array.isArray(diseases)) {
        const currentDisease = diseases.find((d) => String(d.disease_id) === String(current_disease_id))
        diseaseStatus = currentDisease?.disease_status || ""
      }

      setFormData({
        patient_id,
        name: `${first_name || ""} ${middile_name || ""} ${last_name || ""}`,
        name1: `${first_name || ""} ${middile_name || ""} ${last_name || ""}`,
        Contact: whatsapp_contact_no,
        email: patient_email,
        profileImage1: patient_photo || defaultAvatar,
        branch,
        additionalContact: additional_contact_no,
        dob: date_of_birth,
        height,
        weight,
        occupation,
        idProof: id_proof,
        idNumber: id_number,
        gender,
        spouseName: husband_or_spouse_name,
        age,
        referred_by_manual: referred_by_manual,
        marriageHistory: marriage_history,
        marriageDate: marriage_date,
        currentDisease: patientDetails.currentDiseases,
        current_disease_id: patientDetails.currentDiseases?.disease_id || "",
        diseases,
        disease_names: diseaseIds,
        diseaseStatus: patientDetails.currentDiseases?.disease_status || "",
        spouseOption: spouse_option,
        marriageInfo: marriageInfo || [],
        tempAddressLine1: TemporaryAddress?.address_line1 || "",
        tempAddressLine2: TemporaryAddress?.address_line2 || "",
        tempArea: TemporaryAddress?.area || "",
        tempCity: TemporaryAddress?.city || "",
        tempPincode: TemporaryAddress?.pincode || "",
        tempState: TemporaryAddress?.state || "",
        tempCountry: TemporaryAddress?.country || "",
        permAddressLine1: PermanentAddress?.address_line1 || "",
        permAddressLine2: PermanentAddress?.address_line2 || "",
        permArea: PermanentAddress?.area || "",
        permCity: PermanentAddress?.city || "",
        permPincode: PermanentAddress?.pincode || "",
        permState: PermanentAddress?.state || "",
        permCountry: PermanentAddress?.country || "",
        adName: OtherInfo?.ad_name || "",
        adSet: OtherInfo?.ad_set || "",
        campaignName: OtherInfo?.campaign_name || "",
        leadSource: OtherInfo?.lead_source || "",
        status: OtherInfo?.status || "",
        priority: OtherInfo?.priority || "",
        modifiedBy: OtherInfo?.modified_by || "",
        userType: OtherInfo?.user_type || "",
        treatmentHistory: OtherInfo?.treatment_history || "",
        treatment_completed:
          treatment_completed?.toLowerCase() === "yes" ? "Yes" : "No",

        referredBy: referredBy || null,
        disease_percentage: disease_percentage || "",
        intensity_of_treatment: intensity_of_treatment || "",
        referred_by: referred_by || (referredBy?.patient_id ? String(referredBy.patient_id) : ""),
        telecaller_name: telecaller_name || "",
        reviewProvided: review_provided === "Yes",
        testimonialProvided: testimonial_provided === "Yes",
  admin_review_approval: patientDetails.admin_review_approval || "Pending",
admin_testimonial_approval: patientDetails.admin_testimonial_approval || "Pending",
review_by_role_id: patientDetails.review_by_role_id || null,
testimonial_by_role_id: patientDetails.testimonial_by_role_id || null,
      })
      // setIsTreatmentComplete(treatment_completed === "Yes");
    }
  }, [patientDetails, patientData])
  // family tree
  useEffect(() => {
    if (patientDetails?.patient_id) {
      dispatch(fetchFamilyTreeListAction(patientDetails.patient_id))
    }
  }, [dispatch, patientDetails?.patient_id])
  const patientLink = patientDetails?.patient_link;
  // ✅ Ensure patients list is fetched once patient details are ready

  const getFullName = (person) => {
    if (!person) return "-"
    return [person.first_name, person.middile_name, person.last_name]
      .filter(Boolean)
      .map((n) => n.trim())
      .join(" ")
  }

  // Modal close handlers with data refresh
  const handlePersonalInfoClose = () => {
    setIsPersonalInfoModalOpen(false)
    // Refresh patient details after update
    const patientId = formData.patient_id
    if (patientId) {
      console.log("Refreshing patient details after personal info update")
      dispatch(getPatientDetailsAction(patientId))
    }
  }

  const handleAddressClose = () => {
    setIsAddressModalOpen(false)
    // Refresh patient details after update
    const patientId = formData.patient_id
    if (patientId) {
      console.log("Refreshing patient details after address update")
      dispatch(getPatientDetailsAction(patientId))
    }
  }
  // Replace existing handleWhatsAppClick with this robust version
  const handleWhatsAppClick = (explicitNumber) => {
    // prefer explicitNumber passed from caller, else try common fields
    const raw =
      explicitNumber ||
      formData?.whatsapp_contact_no ||
      formData?.Contact ||
      formData?.additionalContact ||
      "";

    if (!raw) {
      alert("WhatsApp number not available");
      return;
    }

    // keep only digits
    let cleaned = String(raw).replace(/\D/g, "");

    // if number begins with 0 remove leading zeros
    cleaned = cleaned.replace(/^0+/, "");

    // If 10 digits (likely local India mobile), prepend country code 91.
    // Adjust/remove this heuristic if your data has country codes already or different country.
    if (cleaned.length === 10) {
      cleaned = "91" + cleaned;
    }

    // final basic validation (min 10 digits after cleaning)
    if (cleaned.length < 10) {
      alert("Invalid WhatsApp number");
      return;
    }

    // Open WhatsApp (works for mobile + web)
    const waUrl = `https://wa.me/${cleaned}`;
    window.open(waUrl, "_blank", "noopener,noreferrer");
  };


  // function calculateAge(dob) {
  //   const birthDate = new Date(dob)
  //   const today = new Date()
  //   let age = today.getFullYear() - birthDate.getFullYear()
  //   const monthDiff = today.getMonth() - birthDate.getMonth()
  //   const dayDiff = today.getDate() - birthDate.getDate()
  //   // Adjust age if birthday hasn't occurred yet this year
  //   if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
  //     age--
  //   }
  //   return age
  // }
  function calculateAge(dob) {
    if (!dob || dob === "0000-00-00") return "-"; // ✅ show "-" if invalid

    const birthDate = new Date(dob);
    if (isNaN(birthDate)) return "-"; // ✅ handle invalid date

    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    const dayDiff = today.getDate() - birthDate.getDate();

    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
      age--;
    }

    return age >= 0 ? age : "-"; // ✅ avoid negative
  }


  const handleEditProfileClick = () => {
    setIsProfileModalOpen(true)
  }

  const handleChange = (event) => {
    const { name, type, checked, value } = event.target
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }))
  }

  // Get reports from Redux store
  const reportsData =
    useSelector((state) => {
      console.log("Reports from Redux state:", state.reports?.reports)
      return state.reports?.reports
    }) || []

  // Modify the useEffect for reports to include searchTerm
  useEffect(() => {
    const fetchReports = async () => {
      if (patientId) {
        setLoadingReports(true)
        try {
          await dispatch(getReportsAction(patientId, searchTerm))
        } catch (error) {
          console.error("Error fetching reports:", error)
          showErrorAlert("Failed to fetch reports")
        } finally {
          setLoadingReports(false)
        }
      }
    }
    // Add debounce to avoid too many API calls
    const debounceTimer = setTimeout(() => {
      fetchReports()
    }, 500) // Wait for 500ms after user stops typing
    return () => clearTimeout(debounceTimer)
  }, [dispatch, patientId, searchTerm]) // Add searchTerm as dependency
  function parseFileName(fileName) {
    if (!fileName) return "";
    const parts = fileName.split("_");
    return parts.length > 1 ? parts.slice(1).join("_") : fileName;
  }

  // Remove the local filtering logic
  // const filteredReports = (reportsData || []).map((r) => {
  //   const parsedName = parseFileName(r.report_file);

  //   return {
  //     ...r,

  //     report_title: r.report_title || parsedName,

  //     report_date:
  //       r.report_date ||
  //       (r.created_at ? r.created_at.split(" ")[0] : "-"),

  //     // ✅ KEEP FILE ID
  //     report_files: (r.report_files || []).map((file) => ({
  //       report_file_id: file.report_file_id,  // ✅ ADD THIS
  //       url: file.report_file_url,
  //       type: file.report_file_url?.toLowerCase().endsWith(".pdf")
  //         ? "pdf"
  //         : "image",
  //     })),
  //   };
  // });
  const filteredReports = (reportsData || [])
  .filter((r) => r) // ✅ remove undefined/null reports
  .map((r) => {
    const parsedName = parseFileName(r?.report_file);

    return {
      ...r,

      report_title: r?.report_title || parsedName,

      report_date:
        r?.report_date ||
        (r?.created_at ? r.created_at.split(" ")[0] : "-"),

      report_files: (r?.report_files || [])
        .filter((file) => file && file.report_file_url) // ✅ FIX
        .map((file) => ({
          report_file_id: file.report_file_id,
          url: file.report_file_url,
          type: file.report_file_url.toLowerCase().endsWith(".pdf")
            ? "pdf"
            : "image",
        })),
    };
  });


  const handleShowChart = () => {
    setShowChart(true)
  }

  const handleCloseChart = () => {
    setShowChart(false)
  }

  const [selectedRecipient, setSelectedRecipient] = useState("")
  // const handleSubmitIn = async () => {
  //   if (!patientId) {
  //     showErrorAlert("Patient ID not found")
  //     return
  //   }
  //   try {
  //     setSendingReportLink(true)
  //     // Get admin_id but don't require it
  //     const admin_id = localStorage.getItem("admin_id")
  //     const linkData = {
  //       patient_id: patientId,
  //       send_to: selectedRecipient.toUpperCase(), // Use the selected recipient
  //       ...(admin_id && { doctor_id: admin_id }), // Only include doctor_id if admin_id exists
  //     }
  //     await dispatch(sendReportLinkAction(linkData))
  //     // Close the report modal and redirect to ReportUpload page in new tab
  //     setIsReportModalOpen(false)
  //     //handleSuccess("Link send successfully");
  //   } catch (error) {
  //     console.error("Failed to send report link:", error)
  //     showErrorAlert("Failed to send report link: " + error.message)
  //   } finally {
  //     setSendingReportLink(false)
  //   }
  // }

  // image on click
  // const handleSubmitIn = async () => {
  //   if (!patientId) {
  //     showErrorAlert("Patient ID not found")
  //     return
  //   }

  //   try {
  //     setSendingReportLink(true)

  //     const admin_id = localStorage.getItem("admin_id")

  //     const linkData = {
  //       patient_id: patientId,
  //       ...(selectedRecipient !== "doctor" && {
  //         send_to: selectedRecipient.toUpperCase(),
  //       }),


  //       ...(selectedRecipient === "doctor"
  //         ? { doctor_id: selectedDoctorId }
  //         : admin_id && { doctor_id: admin_id }),
  //     }

  //     await dispatch(sendReportLinkAction(linkData))

  //     setIsReportModalOpen(false)

  //   } catch (error) {
  //     console.error("Failed to send report link:", error)
  //     showErrorAlert("Failed to send report link: " + error.message)
  //   } finally {
  //     setSendingReportLink(false)
  //   }
  // }

  const handleSubmitIn = async () => {
    if (!patientId) {
      showErrorAlert("Patient ID not found");
      return;
    }

    if (selectedRecipient === "doctor" && !selectedDoctorId) {
      setDoctorError("Please select a doctor");
      return;
    }

    try {
      setSendingReportLink(true);

      const admin_id = localStorage.getItem("admin_id");

      const linkData = {
        patient_id: patientId,
        send_to: selectedRecipient.toUpperCase(), // ✅ PATIENT or DOCTOR

        ...(selectedRecipient === "doctor"
          ? { doctor_id: selectedDoctorId }       // ✅ real doctor
          : { admin_id }),                        // ✅ admin for patient
      };

      console.log("PAYLOAD:", linkData);

      await dispatch(sendReportLinkAction(linkData));

      setIsReportModalOpen(false);
    } catch (error) {
      console.error("Failed to send report link:", error);
      showErrorAlert("Failed to send report link: " + error.message);
    } finally {
      setSendingReportLink(false);
    }
  };
  const [showPrescriptionModal, setShowPrescriptionModal] = useState(false) // State for prescription modal
  const [selectedPrescription, setSelectedPrescription] = useState(null) // State for selected prescription
  const [showDetailModal, setShowDetailModal] = useState(false) //

  const prescriptionData = [
    {
      prescribedBy: "Dr. John Doe",
      date: "Jan 12, 2025",
      diseases: "Blood Test, Fever",
      status: "Pending",
    },
    {
      prescribedBy: "Dr. John Doe",
      date: "Jan 13, 2025",
      diseases: "Blood Test",
      status: "Delivered",
    },
    {
      prescribedBy: "Dr. John Doe",
      date: "Jan 1, 2025",
      diseases: "Blood Test, Fever",
      status: "Pending",
    },
  ]

  const handleViewClick = (prescription) => {
    setSelectedPrescription(prescription) // Set the selected prescription
    setShowDetailModal(true) // Open the detail modal
  }

  const [modifiedPrescriptions, setModifiedPrescriptions] = useState([
    {
      medicineName: "Eladi Gaan kadha",
      dose: "1",
      frequency: "BD - Morning (5am to 9am) - Evening (4pm to 7pm)",
      quantity: "3", // Updated quantity
      deliveredQuantity: "2", // Added delivered quantity
      howToTake:
        "Boil half a teaspoon of the medicine + 2 cups of water together, save half a cup of water, then strain and drink.",
    },
    // ... other prescriptions
  ])

  //prescription
  const [prescriptions, setPrescriptions] = useState([
    {
      medicineName: "Eladi Gaan kadha",
      dose: "1",
      frequency: "BD - Morning (5am to 9am) - Evening (4pm to 7pm)",
      quantity: "1",
      howToTake:
        "Boil half a teaspoon of the medicine + 2 cups of water together, save half a cup of water, then strain and drink.",
    },
    // ... other prescriptions
  ])

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [newPrescription, setNewPrescription] = useState({
    medicineName: "",
    dose: "",
    frequency: "",
    quantity: "",
    howToTake: "",
  })

  // tooltip
  const handleInputChange = (e) => {
    const { name, value } = e.target
    setNewPrescription({ ...newPrescription, [name]: value })
  }

  const handleOnSubmit = () => {
    setPrescriptions([...prescriptions, newPrescription])
    setNewPrescription({
      medicineName: "",
      dose: "",
      frequency: "",
      quantity: "",
      howToTake: "",
    })
    // Close the modal
    setIsModalOpen(false)
  }

  const handleOnDelete = (index) => {
    const updatedPrescriptions = prescriptions.filter((_, i) => i !== index)
    setPrescriptions(updatedPrescriptions)
  }

  const handleGeneratePrescription = () => {
    handleSuccess("Prescription generated!")
  }

  //notes
  //gapld
  const [data, setData] = useState({
    g1: [
      "Jan 2020",
      "Hormonal Treatment",
      "",
      "",
      "Natural",
      "Chromosomal Abnormalities",
      <div key="uniqueKey" style={{ whiteSpace: "pre-line" }}>
        {"G1\nJan 2020\nAbortion\nHormonal Treatment\nMiscarriage:\nNatural"}
      </div>,
    ],
    // ... other data
  })

  const attributes = [
    "Abortion Month, Year, Date of Birth - Age",
    "Which RX helped to maintain pregnancy?",
    "How was the delivery?",
    "Male/Female",
    "How did the miscarriage happen?",
    "Miscarriage Reason",
    "",
  ]

  const attribute = [
    "Age of first menstruation ",
    "Menstruation",
    "How long has menstruation stopped?",
    "What causes menstruation?",
    "How many days does menstruation occur?",
  ]

  // reports
  const [isReportModalOpen, setIsReportModalOpen] = useState(false)

  // transaction
  // Transaction History
  const transactions = [
    {
      id: 1,
      date: "2025-04-01",
      description: "Consultation with Dr. A",
      amountPaid: 500,
      totalAmount: 800,
    },
    {
      id: 2,
      date: "2025-04-05",
      description: "Blood Test",
      amountPaid: 300,
      totalAmount: 300,
    },
    {
      id: 3,
      date: "2025-04-10",
      description: "X-Ray",
      amountPaid: 0,
      totalAmount: 600,
    },
  ]

  const handlePreviewClick = () => {
    setIsReportModalOpen(true)
  }

  const handleSendLinkToPatient = () => {
    // Logic to send link to patient
    console.log("Link sent to patient")
    setIsReportModalOpen(false)
  }

  const handleSendLinkToDoctor = () => {
    // Logic to send link to doctor
    console.log("Link sent to doctor")
    setIsReportModalOpen(false)
  }

  // personal info
  const handleOnChange = (e) => {
    const { name, value } = e.target
    setFormData({ ...formData, [name]: value })
  }

  const handleGenderChange = (selectedOption) => {
    setFormData({ ...formData, gender: selectedOption.value })
  }

  const handleMarriageHistoryChange = (selectedOption) => {
    setFormData({ ...formData, marriageHistory: selectedOption.value })
  }

  const handleCurrentDiseaseChange = async (selectedOption) => {
    setFormData({ ...formData, currentDisease: selectedOption.value })
    
    // Reset treatment_completed to "No" when disease is changed
    const patientId = formData.patient_id;
    if (patientId) {
      try {
        const apiFormData = new FormData();
        apiFormData.append("patient_id", patientId);
        apiFormData.append("treatment_completed", "No");

        const response = await axiosInstance.post(
          "/admin/updateTreatmentStatus",
          apiFormData
        );

        if (response?.data?.status === true) {
          setFormData(prev => ({
            ...prev,
            treatment_completed: "No",
            currentDisease: selectedOption.value
          }));
          handleSuccess("Treatment status reset");
        }
      } catch (error) {
        console.error("Error resetting treatment status:", error);
        // Don't show error alert to avoid disrupting user workflow
      }
    }
  }

  const handleStatusChange = (selectedOption) => {
    setFormData({ ...formData, diseaseStatus: selectedOption.value })
  }

  const handleSpouseOptionChange = (e) => {
    setFormData({ ...formData, spouseOption: e.target.value })
  }

  const handleINChange = (group, index, value) => {
    setData((prevData) => {
      const updatedData = { ...prevData }
      updatedData[group][index] = value
      return updatedData
    })
  }

  // Handle form submission
  const handleSave = (e) => {
    e.preventDefault()
    // Handle form submission logic here
    console.log({
      patientName,
      medicineDetails,
      lastNotes,
      selectedDiseases: selectedDiseases.map((option) => option.value),
    })
  }

  // disease
  const diseaseOptions = [
    { value: "diabetes", label: "Diabetes" },
    { value: "sleepProblem", label: "Sleep Problem" },
    { value: "dentalCare", label: "Dental Care" },
    { value: "hypertension", label: "Hypertension" },
  ]

  const handleSubmitDiseases = (e) => {
    e.preventDefault()
    console.log("Diseases Data:", formData.diseases)
    setIsDiseaseModalOpen(false) // Close the modal after submission
  }

  const handleEditDiseaseClick = () => {
    setIsDiseaseModalOpen(true)
  }

  const handleMultiSelectChange = (selectedOptions) => {
    const selectedValues = selectedOptions ? selectedOptions.map((option) => option.value) : []
    setFormData((prevState) => ({
      ...prevState,
      diseases: selectedValues,
    }))
  }

  const handleSubmitProfile = (e) => {
    e.preventDefault()
    console.log("Updated Profile Data:", formData)
    setIsProfileModalOpen(false) // Close the modal after submission
  }

  const handleImageChange = (event) => {
    const file = event.target.files[0]
    if (file) {
      setSelectedImage(file)
      setImagePreview(URL.createObjectURL(file)) // Create a preview URL for the image
    } else {
      setSelectedImage(null)
      setImagePreview(null)
    }
  }

  const calculateBMI = (w, h) => {
    if (w > 0 && h > 0) {
      setBmi((w / (h * h)) * 10000) // BMI formula for cm/kg
    } else {
      setBmi("")
    }
  }

  const handleWeightChange = (e) => {
    const w = e.target.value
    setWeight(w)
    calculateBMI(w, height)
  }

  const handleHeightChange = (e) => {
    const h = e.target.value
    setHeight(h)
    calculateBMI(weight, h)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    // Handle form submission logic here
    console.log({
      systolicBP,
      diastolicBP,
      weight,
      height,
      bmi,
      pulseRate,
      temperature,
      oxygenSaturation,
      bloodGlucose,
      allergies,
      reports,
    })
  }

  const openModal = () => setIsModalVisible(true)
  const closeModal = () => setIsModalVisible(false)
  const handleShow = () => setShowModal(true)
  const handleClose = () => {
    setShowModal(false)
    setNoteDescription("")
  }

  const handleEditAddressClick = () => {
    setIsAddressModalOpen(true)
  }

  const handleSubmitAddress = (e) => {
    e.preventDefault()
    console.log("Address Data:", formData)
    setIsAddressModalOpen(false) // Close the modal after submission
  }

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files)
    setUploadedFiles((prevFiles) => [...prevFiles, ...files])
  }

  const handleView = (file) => {
    const fileURL = URL.createObjectURL(file)
    window.open(fileURL, "_blank")
  }

  const handleDelete = (index) => {
    setUploadedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index))
  }

  // notes modal;
  const roleOptions = [
    { value: "counselor", label: "Counselor" },
    { value: "medical", label: "Medical" },
  ]

  const handleInChange = (e) => {
    const { name, value } = e.target
    setFormData({ ...formData, [name]: value })
  }

  const handleinSubmit = (e) => {
    e.preventDefault()
    // Handle form submission logic here
    console.log(formData)
  }

  const handleAddNote = () => {
    const newNote = {
      description: noteDescription,
      type: noteType,
      roles: selectedRoles.map((role) => role.value),
    }
    console.log("Note Type:", noteType)
    console.log("Selected Roles:", selectedRoles)
    console.log("New Note:", newNote)
    // Reset the form
    setNoteDescription("")
    setNoteType("self")
    setSelectedRoles([])
    handleClose() // Close the modal
  }

  const renderEventContent = (eventInfo) => {
    return (
      <div
        style={{
          padding: "10px",
          borderRadius: "5px",
          backgroundColor: "transparent",
        }}
      >
        <strong>{eventInfo.event.title}</strong>
      </div>
    )
  }

  const handleEventClick = (eventClickInfo) => {
    const event = eventClickInfo.event
    if (event.title === "Booked") {
      Swal.fire({
        title: event.title,
        text: "TimeSlot Already Booked.",
        icon: "info",
      })
    }
  }

  const formatTime = (dateStr, addHours = 0) => {
    const date = new Date(dateStr)
    date.setHours(date.getHours() + addHours)
    return date.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })
  }

  // const formatDate = (dateStr) => {
  //   const date = new Date(dateStr)
  //   return date.toLocaleDateString("en-IN", {
  //     day: "2-digit",
  //     month: "short",
  //     year: "numeric",
  //   })
  // }
  const handleMouseDown = (e) => {
    setDragStartX(e.clientX);
    setIsDragging(true);
  };

  const handleMouseUp = (e) => {
    if (!isDragging) return;

    const dragEndX = e.clientX;
    const diff = dragStartX - dragEndX;

    if (Math.abs(diff) > 50) {
      // Drag left → Next image
      if (diff > 0) {
        setPreviewIndex((prev) => (prev + 1) % previewGallery.length);
      }
      // Drag right → Prev image
      else {
        setPreviewIndex((prev) => (prev - 1 + previewGallery.length) % previewGallery.length);
      }
    }

    setIsDragging(false);
    setDragStartX(null);
  };

  const handleDateClick = (info) => {
    const calendarApi = info.view.calendar
    const viewMode = calendarApi.view.type
    const formattedDate = formatDate(info.dateStr)
    const startTime = formatTime(info.dateStr)
    const endTime = formatTime(info.dateStr, 1)
    const timeSlot = startTime + " - " + endTime
    const timeSlots = [
      "09:00 AM - 10:00 AM",
      "10:00 AM - 11:00 AM",
      "11:00 AM - 12:00 PM",
      "12:00 PM - 01:00 PM",
      "01:00 PM - 02:00 PM",
      "02:00 PM - 03:00 PM",
      "03:00 PM - 04:00 PM",
      "04:00 PM - 05:00 PM",
      "05:00 PM - 06:00 PM",
      "06:00 PM - 07:00 PM",
      "07:00 PM - 08:00 PM",
      "08:00 PM - 09:00 PM",
    ]
    let timeSlotHTML = ""
    if (viewMode === "dayGridMonth") {
      timeSlotHTML = `
        <div style="display: flex; flex-wrap: wrap; gap: 10px;">
          ${timeSlots
          .map(
            (slot, index) => `
            <div style="display: flex; align-items: center; width: 48%; margin-bottom: 5px;">
              <input type="radio" name="timeSlot" id="slot${index}" value="${slot}"
                 ${slot === "11:00 AM - 12:00 PM" || slot === "06:00 PM - 07:00 PM" ? "disabled" : ""}>
              <label for="slot${index}" style="margin-left: 5px; ${slot === "11:00 AM - 12:00 PM" || slot === "06:00 PM - 07:00 PM" ? "color: lightgray" : ""
              }">
                ${slot}
              </label>
            </div>
          `,
          )
          .join("")}
        </div>
      `
    } else if (viewMode === "timeGridWeek" || viewMode === "timeGridDay") {
      timeSlotHTML = `
        <div style="display: flex; flex-direction: column; gap: 10px; text-align: left;">
          <div style="display: flex; align-items: center; gap: 10px;">
            <input type="radio" name="timeSlot" id="timeslot" value="${timeSlot}" checked />
            <label for="timeslot" style="flex-grow: 1;">${timeSlot}</label>
          </div>
        </div>
      `
    }
    Swal.fire({
      title:
        viewMode === "timeGridWeek" || viewMode === "timeGridDay"
          ? `Book TimeSlot for ${formattedDate}`
          : `Select TimeSlot for ${formattedDate}`,
      html: timeSlotHTML,
      showCancelButton: true,
      confirmButtonText: "Book Appointment",
      confirmButtonColor: "#d33",
      cancelButtonText: "Cancel",
      preConfirm: () => {
        const selected = document.querySelector("input[name='timeSlot']:checked")
        if (!selected) {
          Swal.showValidationMessage("Please select a time slot!")
          return false
        }
        return selected.value
      },
    }).then((result) => {
      if (result.isConfirmed && result.value) {
        Swal.fire("Appointment Booked!", `Your appointment is scheduled at ${result.value}.`, "success").then(() => {
          closeModal()
        })
      }
    })
  }

  const handleOnCancel = (name) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You are about to cancel the appointment for ${name}.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, cancel it!",
      cancelButtonText: "No, keep it",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Cancelled!", `The appointment for ${name} has been cancelled.`, "success")
      }
    })
  }

  const handleONChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }))
  }

  const handleONSave = () => {
    console.log("Saved:", formData)
    setShowRow(false) // Hide the input row
  }

  const handleDiscard = () => {
    console.log("Discard clicked")
    setFormData({
      medicineName: "",
      dose: "",
      frequency: "",
      quantity: "",
      howToTake: "",
    })
  }

  const handleOpen = () => {
    // Store patient data in sessionStorage before navigating
    const patientDataToPass = {
      patient_id: formData.patient_id,
      name: formData.name1,
      gender: formData.gender,
      age: formData.age || (formData.dob ? calculateAge(formData.dob) : "-"),
      weight: formData.weight,
      occupation: formData.occupation,
      currentDisease: formData.currentDisease,
      diseaseStatus: formData.diseaseStatus,
      profileImage: formData.profileImage1,
      marriageHistory: formData.marriageHistory || "-",
      marriageDate: formData.marriageDate || "-",
      spouseName: latestMarriage?.husband_or_spouse_name || "-",
      spouseOption: latestMarriage?.spouse_option || latestMarriage?.spouseOption || "-",
      branch: formData.branch || "-",
      additionalContact: formData.additionalContact || "-",
    }
    // Store the data in sessionStorage
    sessionStorage.setItem("casePaperPatientData", JSON.stringify(patientDataToPass))
    // Navigate to the case paper page with patient ID in URL
    const patientId = formData.patient_id
    window.open(`/case-paper/${patientId}`, "_blank", "noopener,noreferrer")
  }

  const durationOptions = [
    { value: "1 week", label: "1 week" },
    { value: "2 weeks", label: "2 weeks" },
    { value: "3 weeks", label: "3 weeks" },
    { value: "4 weeks", label: "4 weeks" },
    { value: "5 weeks", label: "5 weeks" },
    { value: "6 weeks", label: "6 weeks" },
  ]

  const handleChangeon = (selectedOption) => {
    setDuration(selectedOption) // Update the duration state
  }


  const handleMarriageInfoChange = (e) => {
    const { name, value } = e.target
    if (latestMarriageIndex !== null) {
      const updatedMarriageInfo = [...formData.marriageInfo]
      updatedMarriageInfo[latestMarriageIndex] = {
        ...updatedMarriageInfo[latestMarriageIndex],
        [name]: value,
      }
      setFormData({
        ...formData,
        marriageInfo: updatedMarriageInfo,
      })
    }
  }

  const latestMarriageIndex =
    formData.marriageInfo?.length > 0
      ? [...formData.marriageInfo]
        .map((m, index) => ({ ...m, index }))
        .filter((m) => m.date_of_marriage)
        .sort((a, b) => new Date(b.date_of_marriage) - new Date(a.date_of_marriage))[0]?.index
      : null

  const latestMarriage = latestMarriageIndex !== null ? formData.marriageInfo[latestMarriageIndex] : null

  const handleSpouseNameChange = (e) => {
    if (latestMarriageIndex === null) return
    const newValue = e.target.value
    const updatedMarriageInfo = [...formData.marriageInfo]
    updatedMarriageInfo[latestMarriageIndex] = {
      ...updatedMarriageInfo[latestMarriageIndex],
      husband_or_spouse_name: newValue,
    }
    setFormData((prev) => ({
      ...prev,
      marriageInfo: updatedMarriageInfo,
    }))
  }
  useEffect(() => {
    if (!patientDetails?.marriageInfo?.length) return;

    const latestMarriage = [...patientDetails.marriageInfo]
      .filter((m) => m.date_of_marriage)
      .sort((a, b) => new Date(b.date_of_marriage) - new Date(a.date_of_marriage))[0];

    if (!latestMarriage) {
      setSpouseName("-");
      return;
    }

    // ✅ 1️⃣ If husband_or_spouse_name exists, use it
    if (latestMarriage.husband_or_spouse_name) {
      setSpouseName(latestMarriage.husband_or_spouse_name);
      return;
    }
    //
    // ✅ 2️⃣ Otherwise, use spouse’s first/middle/last name
    if (latestMarriage.first_name || latestMarriage.last_name) {
      const fullSpouseName = [
        latestMarriage.first_name,
        latestMarriage.middile_name,
        latestMarriage.last_name
      ].filter(Boolean).join(" ");
      setSpouseName(fullSpouseName.trim() || "-");
      return;
    }

    // ✅ 3️⃣ Otherwise, look up spouse from patients list
    if (patients?.length) {
      const spousePatient = patients.find(
        (p) =>
          String(p.patient_id) ===
          String(latestMarriage.spouse_details || latestMarriage.spouseDetails)
      );
      if (spousePatient) {
        setSpouseName(spousePatient.patient_name || spousePatient.name || "-");
        return;
      }
    }

    // ✅ 4️⃣ Fallback
    setSpouseName("-");
  }, [patients, patientDetails]);
  useEffect(() => {
    if (formData?.patient_id) {
      fetchWeightChartData(formData.patient_id);
    }
  }, [formData?.patient_id]);

  // ✅ Helper to clean malformed patient photo URLs
  const getValidPhotoUrl = (photoUrl) => {
    if (!photoUrl) return defaultAvatar;

    // If multiple "https://" exist, keep only the last valid part
    if ((photoUrl.match(/https:\/\//g) || []).length > 1) {
      const parts = photoUrl.split("https://");
      return "https://" + parts[parts.length - 1];
    }

    return photoUrl;
  };


  const handlePatientClick = (patient) => {
    console.log("Navigating to patient:", patient.patient_id);
    navigate(`/patients/patient-details/${patient.patient_id}`);
  };
// ⭐ Testimonial API
const handleTestimonialChange = async (e) => {
  const checked = e.target.checked;

  setFormData((prev) => ({
    ...prev,
    testimonialProvided: checked,
  }));

  try {
    await axiosInstance.post("patient/testimonialProvided", {
      patient_id: patientId,
      testimonial_provided: checked ? "Yes" : "No",
    });

    Swal.fire("Success", "Testimonial updated", "success");
  } catch (error) {
    Swal.fire("Error", "Failed to update testimonial", "error");
  }
};
const handleSendPatientLink = async () => {
  if (!patientId) {
    Swal.fire("Error", "Patient ID missing", "error");
    return;
  }

  try {
    setSendingLink(true); // 🔥 start loader

    await axiosInstance.post("/patient/sendPatientLink", {
      patient_id: patientId,
    });

    Swal.fire("Success", "Patient link sent successfully", "success");
    setShowActionModal(false);
  } catch (error) {
    console.error(error);
    Swal.fire("Error", "Failed to send patient link", "error");
  } finally {
    setSendingLink(false); // 🔥 stop loader
  }
};
// ⭐ Google Review API
const handleGoogleReviewChange = async (e) => {
  const checked = e.target.checked;

  setFormData((prev) => ({
    ...prev,
    reviewProvided: checked,
  }));

  try {
    await axiosInstance.post("patient/reviewProvided", {
      patient_id: patientId,
      review_provided: checked ? "Yes" : "No",
    });

    Swal.fire("Success", "Google review updated", "success");
  } catch (error) {
    Swal.fire("Error", "Failed to update review", "error");
  }
};
  const tabStyle = (key) => ({
    backgroundColor: activeKey === key ? "#005f66" : "transparent",
    color: activeKey === key ? "#ffffff" : "#005f66",
    borderRadius: "6px",
    transition: "all 0.2s ease-in-out",
    padding: "10px 18px",
    fontSize: "16px",
    fontWeight: "600",
    fontSize: "20px"

  });


  const fetchWeightChartData = async (patientId) => {
    try {
      const response = await axiosInstance.post("/admin/weightChart", {
        patient_id: patientId,
      })

      if (response.data.status === "success" && response.data.data.length > 0) {
        // Sort by created_at and get the latest entry
        const sortedData = response.data.data.sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        )
        const latest = sortedData[0]
        setLatestWeightData(latest)
        setWeightChartData(response.data.data)
        setShouldHideWeightSection(false)
      } else {
        // No weight chart data, will fall back to detail page weight
        setLatestWeightData(null)
        setWeightChartData(null)
        // Don't hide yet - check if detail page has weight
      }
    } catch (err) {
      console.error("Error fetching weight chart:", err)
      setLatestWeightData(null)
    }
  }


  const isReviewDisabled = () => {
    const approvalStatus = (
      formData?.admin_review_approval || ""
    ).trim().toLowerCase();
  
    const roleId = Number(userDetails?.role_id);
  
    // Disable only when approved
    if (approvalStatus === "approved") {
      return true;
    }
  
    // Allow Admin(1), Counsellor(4), Servicecaller(6)
    return ![1, 4, 6].includes(roleId);
  };
  
  const isTestimonialDisabled = () => {
    const approvalStatus = (
      formData?.admin_testimonial_approval || ""
    ).trim().toLowerCase();
  
    const roleId = Number(userDetails?.role_id);
  
    // Disable only when approved
    if (approvalStatus === "approved") {
      return true;
    }
  
    // Allow Admin(1), Counsellor(4), Servicecaller(6)
    return ![1, 4, 6].includes(roleId);
  };
  // useEffect(() => {
  //   if (formData?.patient_id) {
  //     fetchWeightChartData(formData.patient_id)

  //     // Determine if weight section should be hidden
  //     const hasWeightChartData = latestWeightData !== null
  //     const hasDetailPageWeight = formData.weight && formData.weight !== "0"

  //     if (!hasWeightChartData && !hasDetailPageWeight) {
  //       setShouldHideWeightSection(true)
  //     } else {
  //       // If there is data from either source, don't hide
  //       setShouldHideWeightSection(false)
  //     }
  //   }
  // }, [formData?.patient_id, latestWeightData, formData.weight]) // Added dependencies

  useEffect(() => {
    if (formData?.patient_id) {
      fetchWeightChartData(formData.patient_id);
    }
  }, [formData?.patient_id]);   // ✅ Only run when patient changes

  // const handleEditReport = (report) => {
  //   setEditReport(report);
  //   setShowEditModal(true);
  // };
  // Re-select doctor after doctors list loads
  useEffect(() => {
    if (isDoctor && userDetails?.doctor_id && doctors.length > 0) {
      setSelectedDoctorId(userDetails.doctor_id);
    }
  }, [doctors, isDoctor, userDetails]);

  // Auto-select doctor when modal opens
  useEffect(() => {
    if (isReportModalOpen && roleName === "Doctor" && userDetails?.doctor_id) {
      setSelectedDoctorId(userDetails.doctor_id);
    }
  }, [isReportModalOpen, roleName, userDetails]);

  // Auto-select when "Send to Doctor" radio chosen
  useEffect(() => {
    if (selectedRecipient === "doctor" && roleName === "Doctor") {
      setSelectedDoctorId(userDetails?.doctor_id);
    }
  }, [selectedRecipient, roleName]);

  // / Render loading state
  if (isLoading) {
    return (
      <>
        <Loader />
      </>
    )
  }

  // Function to render dynamic form tab content
  const renderDynamicFormContent = (group) => {
    return (
      <div className="card-body msg_card_body" style={{ maxHeight: "600px", overflowY: "auto" }}>
        {/* Group Header */}
        {/* <div className="mb-3 custom-timeline-panel timeline-panel bgl-dark flex-wrap border-0 p-3 rounded">
          <h6 className="fw-bold text-center mb-0">{group.group_name}</h6>
        </div> */}

        {/* Questions */}
        {group.questions && group.questions.length > 0 ? (
          group.questions.map((question, questionIndex) => (
            <div
              key={`question-${question.question_answer_id}-${questionIndex}`}
              className="mb-2 custom-timeline-panel timeline-panel bgl-dark flex-wrap border-0 p-3 rounded"
            >
              {/* Question */}
              <h6 className="fw-bold">
                Question: {question.short_form?.trim()
                  ? question.short_form
                  : question.label || question.question || "No question"}
              </h6>
              {/* Answer */}
              <h6 className="fw-bold mb-1">Answer: {question.answer || "No answer provided"}</h6>
            </div>
          ))
        ) : (
          <div className="text-center text-muted py-4">
            <i className="fa fa-info-circle fa-2x mb-2"></i>
            <p>No questions found in this group.</p>
          </div>
        )}
      </div>
    )
  }

  return (

    <>



      <div className="form-head d-flex mb-3 mb-md-4 align-items-center justify-content-between">
        <div className="mr-auto d-lg-block">
          <h2 className="text-black font-w600 mb-0">{isLoading ? "Loading..." : <></>}</h2>
        </div>
        {/* <div>
          <Link to={`/app-patients`} className="btn btn-link p-0 m-0 d-flex align-items-center">
            <Button variant="primary">Back</Button>
          </Link>
        </div> */}
      </div>
      <div className="row">
        <div className="container-fluid px-4" style={{ paddingTop: "-60px", marginTop: "-60px", boxSizing: "border-box" }}>
          <div className="row">
            <div className="col-xl-4">
              <div className="row">
                <div className="col-lg-12 ">
                  <div className="card">
                    <div className="card-body pt-4">
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <h4 className="mb-0">Personal Information   </h4>

                        <i
                          className={`fa ${showPersonalInfo ? "fa-chevron-up" : "fa-chevron-down"} fs-4`}
                          style={{ cursor: "pointer" }}
                          onClick={() => setShowPersonalInfo(prev => !prev)}
                        ></i>

                      </div>
                      {showPersonalInfo && (
                        <>
                          <div className="media d-sm-flex d-block text-center text-sm-start pb-4 mb-4 border-bottom">
                            <img
                              alt=""
                              className="rounded me-sm-4 me-0"
                              width={100}
                              // src={formData.profileImage1 || defaultAvatar}
                              src={getValidPhotoUrl(formData.profileImage1) || "/placeholder.svg"}
                              onError={(e) => (e.currentTarget.src = defaultAvatar)}
                            />
                            <div className="media-body align-items-center">
                              <div className="d-sm-flex d-block justify-content-between align-items-center my-3 my-sm-0">
                                <div>
                                  <h3 className="fs-22 text-black font-w600 mb-0">
                                    {formData.name1 || "Patient Name"}


                                  </h3>
                                </div>

                                <span className="d-inline-flex align-items-center gap-3 me-3">
                                  <img
                                    src={icon3 || "/placeholder.svg"}
                                    alt="patient icon"
                                    onClick={handleOpen}
                                    style={{ cursor: "pointer", width: "28px", height: "24px" }}
                                    title="case-paper"
                                  />

                                  <i
                                    className="fa fa-pencil fs-18 text-success"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => setIsPersonalInfoModalOpen(true)}
                                    title="Edit Personal Info"
                                  ></i>
                                </span>
                              </div>

                              <div className="d-flex align-items-center gap-3">

                                <Link to="#" className="btn bgl-primary btn-rounded text-black " title={formData.gender ? ` ${formData.gender}` : "No gender selected"}>
                                  {formData.gender === "Male" && (
                                    <>
                                      <svg
                                        className="me-2 scale5"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M14 2H22V10H20V5.41L15.71 9.71C16.45 10.79 16.91 12.1 16.98 13.5C17.17 17.14 14.32 20.24 10.68 20.48C6.79 20.74 3.5 17.6 3.5 13.71C3.5 9.82 6.65 6.53 10.54 6.29C11.94 6.2 13.25 6.66 14.34 7.41L18.59 3H14V2Z"
                                          fill="#2BC155"
                                        />
                                      </svg>
                                      M
                                    </>
                                  )}
                                  {formData.gender === "Female" && (
                                    <>
                                      <svg
                                        className="me-2 scale5"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M12 2C8.13 2 5 5.13 5 9C5 12.52 7.61 15.44 11 15.93V18H8V20H11V22H13V20H16V18H13V15.93C16.39 15.44 19 12.52 19 9C19 5.13 15.87 2 12 2ZM12 13C9.24 13 7 10.76 7 8C7 5.24 9.24 3 12 3C14.76 3 17 5.24 17 8C17 10.76 14.76 13 12 13Z"
                                          fill="#C92A2A"
                                        />
                                      </svg>
                                      F
                                    </>
                                  )}
                                  {formData.gender === "Transgender" && (
                                    <>
                                      <svg
                                        className="me-2 scale5"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M19 3h-2.59l1.3 1.29-2.83 2.83c-.85-.54-1.84-.87-2.88-.98V4h1V2h-4v2h1v2.14c-2.79.47-5 2.93-5 5.86 0 3.31 2.69 6 6 6 .57 0 1.11-.08 1.63-.24l1.63 1.63V20h-2v2h4v-2h-1v-1.17l-1.41-1.41c1.48-.98 2.46-2.65 2.46-4.59 0-1.04-.29-2.02-.78-2.85l2.83-2.83L21 6.59V4h-2V3zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
                                          fill="#C92A2A"
                                        />
                                      </svg>
                                      Trans
                                    </>
                                  )}
                                  {!formData.gender && <span> - </span>}
                                </Link>
                                <FaAddressCard
                                  size={40}
                                  style={{
                                    cursor: "pointer",
                                    padding: "4px",
                                    // marginLeft: "25px",
                                    borderRadius: "6px",
                                    transition: "0.2s",
                                  }}
                                  onMouseEnter={(e) => (e.currentTarget.style.background = "#f2f2f2")}
                                  onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                                  onClick={downloadVCF}
                                  title="Download Contact (.vcf)"
                                />
                                <FaWhatsapp
                                  size={26}
                                  title="Whatsapp"
                                  color="#25D366"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => handleWhatsAppClick(formData.whatsapp_contact_no || formData.Contact || formData.additionalContact)}
                                />


                                {referrals && referrals.length > 0 && (
                                  <OverlayTrigger
                                    placement="right"
                                    popperConfig={{
                                      modifiers: [
                                        { name: "flip", enabled: false },
                                        { name: "preventOverflow", enabled: false },
                                        { name: "hide", enabled: false }
                                      ]
                                    }}
                                    overlay={
                                      <Tooltip arrow={false} style={{ position: "relative" }}>
                                        {referrals.map((ref, index) => (
                                          <div key={ref.patient_id} style={{ marginBottom: "4px" }}>
                                            <strong>Reference {index + 1}:</strong>{" "}
                                            {ref.first_name} {ref.middile_name} {ref.last_name}
                                          </div>
                                        ))}
                                      </Tooltip>
                                    }
                                  >
                                    <span
                                      className="badge bg-success"
                                      style={{
                                        fontSize: "0.75rem",
                                        padding: "6px 10px",
                                        cursor: "pointer",
                                        borderRadius: "12px",
                                      }}
                                    >
                                      {referrals.length}
                                    </span>
                                  </OverlayTrigger>
                                )}

                                <style>
                                  {`
.tooltip .tooltip-arrow {
  display: none !important;
}
.qr-button {
  color: black !important;
}
.qr-button:hover {
  color: black !important;
  text-decoration: none !important;
}
`}
                                </style>

                                <Button
  variant="link"
  size="sm"
  onClick={() => setShowActionModal(true)}
  className="d-flex align-items-center justify-content-center p-0 qr-button"
  title="virtual ID"

>
  <MdQrCode size={26} />
</Button>




                              </div>
                              {isDoctor && (
                                <div className="form-check mt-3">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="treatmentCompleted"
                                    checked={formData.treatment_completed === "Yes"}
                                    onChange={handleTreatmentStatusChange}
                                    disabled={updatingTreatmentStatus || !formData.patient_id}
                                    style={{
                                      cursor: updatingTreatmentStatus ? "not-allowed" : "pointer"
                                    }}
                                  />

                                  <label
                                    className="form-check-label fw-semibold d-flex align-items-center"
                                    htmlFor="treatmentCompleted"
                                    style={{
                                      color: updatingTreatmentStatus ? "#6c757d" : "inherit"
                                    }}
                                  >
                                    Treatment Completed

                                    {updatingTreatmentStatus && (
                                      <span className="spinner-border spinner-border-sm ms-2" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                      </span>
                                    )}
                                  </label>

                                  {updatingTreatmentStatus && (
                                    <small className="text-muted">Updating...</small>
                                  )}
                                </div>
                              )}

                            </div>
                          </div>
                          <div className="row">
                            <div className="row mb-2" >


                              <div className="col-6">
                                <h5 className="f-w-500">Husband/Wife Name:</h5>
                                <span>{spouseName}</span>
                              </div>


                              <div className="col-6">
                                <h5 className="f-w-500">Age:</h5>
                                {(() => {
                                  const ageValue = formData.age || (formData.dob ? calculateAge(formData.dob) : "-");
                                  return ageValue === "-" || ageValue === 0 ? "-" : `${ageValue} years`;

                                })()}

                              </div>
                            </div>
                            <div className="row mb-2">
                              {!shouldHideWeightSection && (
                                <div className="col-6">
                                  <h5 className="f-w-500">Weight (kg):</h5>
                                  <span>
                                    {/* Show latest weight chart data first, then fall back to detail page weight */}
                                    {latestWeightData?.weight
                                      ? latestWeightData.weight
                                      : (formData.weight && formData.weight !== "0" ? formData.weight : "-")}
                                    {(latestWeightData?.weight || (formData.weight && formData.weight !== "0")) && (
                                      <img
                                        src={icon || "/placeholder.svg"}
                                        alt="History Icon"
                                        onClick={handleShowChart}
                                        style={{
                                          cursor: "pointer",
                                          marginLeft: "8px",
                                          width: "24px",
                                          height: "24px",
                                        }}
                                        title=" View Weight History"
                                      />
                                    )}
                                  </span>
                                </div>
                              )}
                              {/* Weight Chart Component */}
                              <WeightChart
                                patientId={formData.patient_id}
                                show={showChart}
                                onClose={handleCloseChart}
                                height={formData.height}
                                gender={formData.gender}
                              />
                              <div className="col-6">
                                <h5 className="f-w-500">Occupation:</h5>
                                <span>{formData?.occupation || "-"}</span>
                              </div>
                            </div>
                            {(() => {
                              const latestMarriage =
                                Array.isArray(formData.marriageInfo) && formData.marriageInfo.length > 0
                                  ? [...formData.marriageInfo]
                                    .filter((m) => m.date_of_marriage)
                                    .sort((a, b) => new Date(b.date_of_marriage) - new Date(a.date_of_marriage))[0]
                                  : null
                              return (
                                <div className="row mb-2">
                                  <div className="col-6">
                                    <h5 className="f-w-500">Marriage History:</h5>
                                    <span>{latestMarriage?.marriage_history || "-"}</span>
                                  </div>
                                  <div className="col-6">
                                    <h5 className="f-w-500">Marriage Date:</h5>
                                    <span>
                                      {latestMarriage?.date_of_marriage
                                        ? formatDate(latestMarriage.date_of_marriage)
                                        : "-"}
                                    </span>
                                  </div>
                                </div>
                              )
                            })()}
                            <div className="row mb-2">
                              {/* <div className="col-6">
                                <h5 className="f-w-500">Current Disease:</h5>
                                <span>
                                  {formData.currentDisease?.disease_name ? formData.currentDisease?.disease_name : "-"}
                                </span> */}
                              {/* <div className="col-4">
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-primary"
                                    onClick={() => setShowDiseaseModal(true)}
                                  >
                                    Disease Curation
                                  </button>
                                </div> */}

                              {/* </div> */}
                              <div className="col-6">
                                <h5 className="f-w-500">Status:</h5>
                                <span>{formData.diseaseStatus || "-"}</span>
                              </div>
                            </div>
                            <div className="row mb-2">
                              {(() => {
                                const latestMarriage =
                                  Array.isArray(formData.marriageInfo) && formData.marriageInfo.length > 0
                                    ? [...formData.marriageInfo]
                                      .filter((m) => m.date_of_marriage)
                                      .sort((a, b) => new Date(b.date_of_marriage) - new Date(a.date_of_marriage))[0]
                                    : null
                                return (
                                  // <div className="col-6">
                                  //   <h5 className="f-w-500">With Spouse:</h5>
                                  //   <span>
                                  //     {latestMarriage?.spouse_option === "withSpouse" ||
                                  //       latestMarriage?.spouseOption === "withSpouse"
                                  //       ? "Yes"
                                  //       : "No"}
                                  //   </span>
                                  // </div>
                                  <div className="col-6">
                                    <h5 className="f-w-500">With Spouse:</h5>
                                    <span>
                                      {(() => {
                                        const option =
                                          latestMarriage?.spouse_option || latestMarriage?.spouseOption || "";

                                        if (!option) return "-"; // when field is missing
                                        if (!option) return "-"; // when field is missing

                                        // normalize spaces and case
                                        const normalized = option.toLowerCase().replace(/\s+/g, "");
                                        return normalized === "withspouse" ? "Yes" : "No";
                                      })()}
                                    </span>
                                  </div>

                                )
                              })()}
                              <div className="col-6">
                                <h5 className="f-w-500">Referred by:</h5>
                                <span>
                                  {formData?.referred_by_manual?.trim()
                                    ? formData.referred_by_manual
                                    : getFullName(formData?.referredBy)}
                                </span>

                              </div>
                              <div className="col-4">
                                <div className="d-flex align-items-center gap-2">
                                  {/* <button
                                    type="button"
                                    className="btn btn-sm btn-primary"
                                    onClick={() => setShowObjectionModal(true)}
                                  >
                                    Objection
                                  </button> */}
                                </div>
                              </div>
                              <div className="row mb-2 mt-2">
                                <div className="col-12">
                                  {/* First line: Label + Flag */}
                                  <div className="d-flex align-items-center gap-2">
                                    <h5 className="f-w-500 mb-0">Cured Disease:</h5>
                                    <img
                                      src={flag}
                                      alt="flag"
                                      style={{
                                        cursor: "pointer",
                                        width: 22,
                                        height: 22,
                                      }}
                                      onClick={() => {
                                        setShowDiseaseModal(true);
                                        const initialDiseases = curedDiseases.map((id) => (!isNaN(id) ? Number(id) : id));
                                        setSelectDiseases(initialDiseases);
                                        setSelectedCurationDiseases(initialDiseases);
                                      }}
                                      title="Update Disease Curation"
                                    />
                                  </div>

                                  {/* Second line: Disease names */}
                                  <div style={{ marginTop: "8px" }}>
                                    <div
                                      style={{
                                        background: "#d4edda",
                                        color: "#0f5132",
                                        padding: "6px 12px",
                                        borderRadius: "6px",
                                        fontWeight: 600,
                                        display: finalCurationDiseases.length > 0 ? "inline-block" : "none",
                                        maxWidth: "100%",
                                        whiteSpace: "normal",
                                        wordBreak: "break-word",
                                        overflowWrap: "break-word",
                                      }}
                                    >
                                      {getCuredDiseaseNames(finalCurationDiseases).join(", ")}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {showObjectionModal && (
                                <div
                                  className="modal fade show"
                                  style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
                                >
                                  <div className="modal-dialog modal-dialog-centered">
                                    <div className="modal-content p-3">

                                      <h5 className="mb-3">Select Objection</h5>

                                      <Select
                                        options={objectionOptions}
                                        isSearchable={true}
                                        isClearable={true}
                                        menuIsOpen={menuOpen}
                                        onMenuOpen={() => setMenuOpen(true)}
                                        onMenuClose={() => setMenuOpen(false)}
                                        onFocus={() => setMenuOpen(true)} // prevents input focus from showing blue highlight
                                        value={
                                          selectedObjection
                                            ? objectionOptions.find((x) => x.value === selectedObjection)
                                            : null
                                        }
                                        onChange={(selected) => {
                                          if (!selected) {
                                            setSelectedObjection("");
                                            setFormData((prev) => ({ ...prev, objection: "" }));
                                            return;
                                          }

                                          setSelectedObjection(selected.value);
                                          setFormData((prev) => ({ ...prev, objection: selected.value }));
                                        }}
                                        placeholder="Select objection"
                                      />

                                      <div className="text-end mt-3">
                                        <button
                                          className="btn btn-primary btn-sm"
                                          onClick={() => setShowObjectionModal(false)}
                                        >
                                          Close
                                        </button>
                                      </div>

                                    </div>
                                  </div>
                                </div>
                              )}

                              {showDiseaseModal && (
                                <div
                                  className="modal fade show"
                                  style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
                                >
                                  <div className="modal-dialog modal-dialog-centered">
                                    <div className="modal-content p-3">

                                      <h5 className="mb-3">Successful Disease Curation</h5>

                                      {diseaseList.map((disease, index) => (
                                        <div className="form-check mb-2" key={disease.disease_id || index}>
                                          <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id={`disease-${disease.disease_id || index}`}
                                            checked={selectDiseases.includes(Number(disease.disease_id))}
                                            disabled={updatingCuredDiseases}
                                            onChange={(e) => {
                                              const diseaseId = Number(disease.disease_id);

                                              if (e.target.checked) {
                                                setSelectDiseases((prev) => [...prev, diseaseId]);
                                              } else {
                                                setSelectDiseases((prev) =>
                                                  prev.filter((d) => d !== diseaseId)
                                                );
                                              }
                                            }}
                                          />
                                          <label className="form-check-label" htmlFor={`disease-${disease.disease_id || index}`}>
                                            {disease.disease_name || disease}
                                            {updatingCuredDiseases && selectDiseases.includes(Number(disease.disease_id)) && (
                                              <span className="ms-2">
                                                <span className="spinner-border spinner-border-sm" role="status">
                                                  <span className="visually-hidden">Loading...</span>
                                                </span>
                                              </span>
                                            )}
                                          </label>
                                        </div>
                                      ))}

                                      <div className="text-end mt-4">
                                        <button
                                          className="btn btn-primary me-2"
                                          disabled={updatingCuredDiseases}
                                          // onClick={() => {
                                          //   setUpdatingCuredDiseases(true);
                                          //   // Deduplicate and normalize disease IDs to numbers
                                          //   const uniqueDiseases = [...new Set(selectDiseases.map(id => Number(id)))];
                                          //   console.log("Selected Cured Diseases:", uniqueDiseases);
                                          //   // Call API to update cured diseases on submit
                                          //   dispatch(updatePatientCuredDiseasesAction(patientId, uniqueDiseases));
                                          //   setFinalCurationDiseases(uniqueDiseases);
                                          //   setTimeout(() => {
                                          //     setUpdatingCuredDiseases(false);
                                          //     setShowDiseaseModal(false);
                                          //   }, 1500);
                                          // }}
                                          onClick={async () => {

                                           if (!selectDiseases.length) {                                         
                                              showErrorAlert(
                                                "Please select at least one disease."
                                              );                                         
                                              return;                                         
                                            }                                         
                                            try {                                         
                                              setUpdatingCuredDiseases(true);
                                               // REMOVE DUPLICATES
                                              const uniqueDiseases = [
                                                ...new Set(
                                                  selectDiseases.map((id) =>
                                                    Number(id)
                                                  )
                                                ),
                                              ];
                                          
                                              console.log(
                                                "Selected Cured Diseases:",
                                                uniqueDiseases
                                              );
                                          
                                              await dispatch(
                                                updatePatientCuredDiseasesAction(
                                                  patientId,
                                                  uniqueDiseases
                                                )
                                              );
                                          
                                              setFinalCurationDiseases(
                                                uniqueDiseases
                                              );
                                          
                                              // handleSuccess(
                                              //   "Cured diseases updated successfully."
                                              // );
                                          
                                              setShowDiseaseModal(false);
                                          
                                            } catch (error) {
                                          
                                              console.error(error);
                                          
                                              showErrorAlert(
                                                "Failed to update cured diseases."
                                              );
                                          
                                            } finally {
                                          
                                              setUpdatingCuredDiseases(false);
                                          
                                            }

                                          }}
                                        >
                                          {updatingCuredDiseases ? "Updating..." : "Submit"}
                                        </button>

                                        <button
                                          className="btn btn-secondary"
                                          disabled={updatingCuredDiseases}
                                          onClick={() => setShowDiseaseModal(false)}
                                        >
                                          Close
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}

                            </div>


                            <PersonalInfoModal
                              isOpen={isPersonalInfoModalOpen}
                              onClose={handlePersonalInfoClose}
                              formData={formData}
                              onSubmit={handlePersonalInfoClose}
                              loading={loading}
                            />
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>


                {/* Modal for Editing Profile */}
                <div className="col-lg-12">
                  <ImportantQuestion></ImportantQuestion>
                </div>
              </div>
              <div className="col-lg-12">
  <div className="card">
    <div className="card-body pt-3 pb-3">
    <div className="d-flex justify-content-between align-items-center mb-4">
                      <h4 className="fs-18 text-black font-w600 mb-0">Reviews</h4>
                    </div>
      <div className="row align-items-center">
        {/* Google Review - Left aligned */}
        <div className="col-6 text-start">
  <div className="form-check d-flex align-items-center justify-content-start m-0">
    <input
      type="checkbox"
      className="form-check-input"
      id="googleReview"
      checked={formData.reviewProvided || false}
      onChange={handleGoogleReviewChange}
      disabled={isReviewDisabled()}
      style={{
        cursor: isReviewDisabled() ? "not-allowed" : "pointer",
        opacity: isReviewDisabled() ? 0.6 : 1,
      }}
    />
    <label
      className="form-check-label ms-2"
      htmlFor="googleReview"
      style={{
        cursor: isReviewDisabled() ? "not-allowed" : "pointer",
        opacity: isReviewDisabled() ? 0.6 : 1,
      }}
    >
      Google Review
    </label>
  </div>
</div>

<div className="col-6 text-center">
  <div className="form-check d-flex align-items-center justify-content-center m-0">
    <input
      type="checkbox"
      className="form-check-input"
      id="testimonialGiven"
      checked={formData.testimonialProvided || false}
      onChange={handleTestimonialChange}
      disabled={isTestimonialDisabled()}
      style={{
        cursor: isTestimonialDisabled() ? "not-allowed" : "pointer",
        opacity: isTestimonialDisabled() ? 0.6 : 1,
      }}
    />
    <label
      className="form-check-label ms-2"
      htmlFor="testimonialGiven"
      style={{
        cursor: isTestimonialDisabled() ? "not-allowed" : "pointer",
        opacity: isTestimonialDisabled() ? 0.6 : 1,
      }}
    >
      Testimonial
    </label>
  </div>
</div>
      </div>
    </div>
  </div>
</div>
              {/* Address details */}
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-body pt-3">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <h4 className="fs-18 text-black font-w600 mb-0">Address Details</h4>
                      <span>
                        <Link
                          to="#"
                          className="edit-staff"
                          onClick={() => setIsAddressModalOpen(true)}
                          title="Edit Address"
                        >
                          <i className="fa fa-pencil fs-18 text-success"></i>
                        </Link>
                      </span>
                    </div>
                    <div className="row mb-2">
                      {/* Temporary Address */}
                      <div className="col-12 mb-3">
                        <h5 className="f-w-500">Temporary Address:</h5>
                        <span>
                          {[
                            formData.tempAddressLine1,
                            formData.tempAddressLine2,
                            formData.tempArea,
                            formData.tempCity,
                            formData.tempState,
                            formData.tempCountry,
                            formData.tempPincode,
                          ]
                            .filter(Boolean)
                            .join(" ") || " - "}
                        </span>
                      </div>
                      {/* Permanent Address */}
                      <div className="col-12">
                        <h5 className="f-w-500">Permanent Address:</h5>
                        <span>
                          {[
                            formData.permAddressLine1,
                            formData.permAddressLine2,
                            formData.permArea,
                            formData.permCity,
                            formData.permState,
                            formData.permCountry,
                            formData.permPincode,
                          ]
                            .filter(Boolean)
                            .join(" ") || " - "}
                        </span>
                      </div>
                    </div>
                    {/* Address Modal */}
                    <AddressModal
                      isOpen={isAddressModalOpen}
                      onClose={handleAddressClose}
                      formData={formData}
                      onSubmit={handleAddressClose}
                      loading={loading}
                    />
                  </div>
                </div>
              </div>
              {/* other information*/}
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <h4 className="fs-18 text-black font-w600 mb-0">Other Information</h4>
                    </div>

                    <div className="row mb-2">
                      <div className="col-6">
                        <h5 className="f-w-500">TeleCaller:</h5>
                        <span>{formData.telecaller_name || "-"}</span>
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-6">
                        <h5 className="f-w-500">Ad Name:</h5>
                        <span>{formData.adName || " - "}</span>
                      </div>
                      <div className="col-6">
                        <h5 className="f-w-500">Ad Set:</h5>
                        <span>{formData.adSet || "-"}</span>
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-6">
                        <h5 className="f-w-500">Campaign Name:</h5>
                        <span>{formData.campaignName || "-"}</span>
                      </div>
                      <div className="col-6">
                        <h5 className="f-w-500">Lead Source:</h5>
                        <span>{formData.leadSource || "-"}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Payment Section */}
            {/* <div className="col-xl-12 mb-4">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <h4 className="fs-18 text-black font-w600 mb-0">
                      Payment Management
                    </h4>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <h6 className="fw-bold mb-2">Patient Email:</h6>
                        <p className="mb-2">
                          {formData.email ? (
                            <span className="text-success">
                              <i className="fas fa-check-circle me-2"></i>
                              {formData.email}
                            </span>
                          ) : (
                            <span className="text-danger">
                              <i className="fas fa-exclamation-circle me-2"></i>
                              No email address found
                            </span>
                          )}
                        </p>
                      </div>

                      <div className="mb-3">
                        <h6 className="fw-bold mb-2">Patient ID:</h6>
                        <p className="mb-2">
                          <span className="text-primary fw-bold">
                            {formData.patient_id}
                          </span>
                        </p>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="d-flex flex-column align-items-end">
                        <h6 className="fw-bold mb-3">Send Payment Link</h6>
                        <SendPaymentLinkButton
                          patientId={formData.patient_id}
                          patientName={formData.name1}
                          email={formData.email}
                          amount={0} // You can set a default amount or make it configurable
                          paymentFor="Patient Services"
                          paymentType="patient_details"
                          className="btn btn-primary"
                          size="md"
                          variant="primary"
                          disabled={!formData.email}
                          onSuccess={() => {
                            Swal.fire({
                              title: "Success!",
                              text: "Payment link sent successfully to patient's email.",
                              icon: "success",
                              confirmButtonText: "OK",
                            });
                          }}
                          onError={(error) => {
                            Swal.fire({
                              title: "Error!",
                              text:
                                error ||
                                "Failed to send payment link. Please try again.",
                              icon: "error",
                              confirmButtonText: "OK",
                            });
                          }}
                        />
                        {!formData.email && (
                          <small className="text-danger mt-2">
                            <i className="fas fa-info-circle me-1"></i>
                            Patient email is required to send payment link
                          </small>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="alert alert-info mt-3">
                    <i className="fas fa-info-circle me-2"></i>
                    <strong>Payment Link Information:</strong>
                    <ul className="mb-0 mt-2">
                      <li>
                        Payment links are sent to the patient's registered email
                        address
                      </li>
                      <li>Links expire after 24 hours for security</li>
                      <li>
                        Patients can complete payment remotely using the link
                      </li>
                      <li>
                        Payment status is automatically updated in the system
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div> */}

            <div className="col-xl-8">
              <div className="card">
                <div className="card-body ">
                  <div className="profile-tab">
                    <div className="custom-tab-1">
                      <Tab.Container defaultActiveKey="noteshistory">
                        {/* <div
                          className="tab-scroll-wrapper"
                          style={{ overflowX: "auto", whiteSpace: "nowrap" }}
                        >
                          <Nav
                            as="ul"
                            className="nav nav-tabs flex-nowrap"
                            style={{ minWidth: "max-content" }}
                          >
                            <Nav.Item as="li" className="nav-item">
                              <Nav.Link eventKey="noteshistory">
                                Notes History
                              </Nav.Link>
                            </Nav.Item>

                            {/* Diseases History 
                            <Nav.Item as="li" className="nav-item">

                              <Nav.Link eventKey="Diseases">
                                Diseases History
                              </Nav.Link>
                            </Nav.Item>
                            {/* Notes 
                            <Nav.Item as="li" className="nav-item">
                              <Nav.Link eventKey="Notes">Notes</Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" className="nav-item">
                              <Nav.Link eventKey="familytree">
                                Family Tree
                              </Nav.Link>
                            </Nav.Item>
                            {/* Prescriptions 
                            <Nav.Item as="li" className="nav-item">
                              <Nav.Link eventKey="Prescriptions">
                                Prescriptions
                              </Nav.Link>
                            </Nav.Item>
                            {/* Female-specific tabs
                            {formData.gender === "Female" && (
                              <>
                                <Nav.Item as="li" className="nav-item">
                                  <Nav.Link eventKey="Menopause">
                                    Menopause
                                  </Nav.Link>
                                </Nav.Item>
                                <Nav.Item as="li" className="nav-item">
                                  <Nav.Link eventKey="GAPLD">GAPLD</Nav.Link>
                                </Nav.Item>
                              </>
                            )}
                            {/* Male-specific tab 
                            {formData.gender === "Male" && (
                              <Nav.Item as="li" className="nav-item">
                                <Nav.Link eventKey="Malechart">
                                  Male Chart
                                </Nav.Link>
                              </Nav.Item>
                            )}
                            {/* Dynamic Form Tabs - Show each group as a separate tab 

                            {/* Reports 
                            <Nav.Item as="li" className="nav-item">
                              <Nav.Link eventKey="Reports">Reports</Nav.Link>
                            </Nav.Item>
                            {/* Transaction History 
                            <Nav.Item as="li" className="nav-item">
                              <Nav.Link eventKey="TransactionHistory">
                                Transaction History
                              </Nav.Link>
                            </Nav.Item>
                            {/* Dynamic Form Tabs - Show each group as a separate tab
                            {tabGroupsArray.map((group) => (
                              <Nav.Item as="li" className="nav-item" key={`nav-${group.group_id}`}>
                                <Nav.Link eventKey={`DynamicForm-${group.group_id}`}>{group.group_name}</Nav.Link>
                              </Nav.Item>
                            ))}
                          </Nav>
                        </div> */}
                        {/* <div
      className="tab-scroll-wrapper"
      style={{
        overflowX: "visible",
        whiteSpace: "normal",
      }}
    >
      <Nav
        as="ul"
        className="nav nav-tabs flex-wrap justify-content-start"
        style={{
          borderBottom: "1px solid #dee2e6",
          rowGap: "8px", // adds space between wrapped rows
        }}
      >
        <Nav.Item as="li" className="nav-item">
          <Nav.Link eventKey="noteshistory">Notes History</Nav.Link>
        </Nav.Item>

        <Nav.Item as="li" className="nav-item">
          <Nav.Link eventKey="Diseases">Diseases History</Nav.Link>
        </Nav.Item>

        <Nav.Item as="li" className="nav-item">
          <Nav.Link eventKey="Notes">Notes</Nav.Link>
        </Nav.Item>

        <Nav.Item as="li" className="nav-item">
          <Nav.Link eventKey="familytree">Family Tree</Nav.Link>
        </Nav.Item>

        <Nav.Item as="li" className="nav-item">
          <Nav.Link eventKey="Prescriptions">Prescriptions</Nav.Link>
        </Nav.Item>

        {formData.gender === "Female" && (
          <>
            <Nav.Item as="li" className="nav-item">
              <Nav.Link eventKey="Menopause">Menopause</Nav.Link>
            </Nav.Item>
            <Nav.Item as="li" className="nav-item">
              <Nav.Link eventKey="GAPLD">GAPLD</Nav.Link>
            </Nav.Item>
          </>
        )}

     
        {formData.gender === "Male" && (
          <Nav.Item as="li" className="nav-item">
            <Nav.Link eventKey="Malechart">Male Chart</Nav.Link>
          </Nav.Item>
        )}

        <Nav.Item as="li" className="nav-item">
          <Nav.Link eventKey="Reports">Reports</Nav.Link>
        </Nav.Item>

        <Nav.Item as="li" className="nav-item">
          <Nav.Link eventKey="TransactionHistory">Transaction History</Nav.Link>
        </Nav.Item>

   
        {tabGroupsArray.map((group) => (
          <Nav.Item as="li" className="nav-item" key={`nav-${group.group_id}`}>
            <Nav.Link eventKey={`DynamicForm-${group.group_id}`}>
              {group.group_name}
            </Nav.Link>
          </Nav.Item>
        ))}
      </Nav>
    </div> */}
                        <div
                          className="tab-scroll-wrapper"
                          style={{
                            overflowX: "visible",
                            whiteSpace: "normal",
                          }}
                        >
                          <Nav
                            as="ul"
                            variant="tabs"
                            activeKey={activeKey}
                            onSelect={(selectedKey) => setActiveKey(selectedKey)}
                            className="nav-tabs flex-wrap justify-content-start custom-tabs"
                            style={{
                              borderBottom: "1px solid #dee2e6",
                              rowGap: "8px",
                            }}
                          >
                            <Nav.Item as="li">
                              <Nav.Link eventKey="noteshistory" style={tabStyle("noteshistory")}>
                                Summary
                              </Nav.Link>
                            </Nav.Item>

                            <Nav.Item as="li">
                              <Nav.Link eventKey="Diseases" style={tabStyle("Diseases")}>
                                Diseases History
                              </Nav.Link>
                            </Nav.Item>

                            <Nav.Item as="li">
                              <Nav.Link eventKey="Notes" style={tabStyle("Notes")}>
                                Notes
                              </Nav.Link>
                            </Nav.Item>

                            <Nav.Item as="li">
                              <Nav.Link eventKey="familytree" style={tabStyle("familytree")}>
                                Family Tree
                              </Nav.Link>
                            </Nav.Item>

                            <Nav.Item as="li">
                              <Nav.Link eventKey="Prescriptions" style={tabStyle("Prescriptions")}>
                                Prescriptions
                              </Nav.Link>
                            </Nav.Item>

                            {formData.gender === "Female" && (
                              <>
                                <Nav.Item as="li">
                                  <Nav.Link eventKey="Menopause" style={tabStyle("Menopause")}>
                                    LMP
                                  </Nav.Link>
                                </Nav.Item>
                                <Nav.Item as="li">
                                  <Nav.Link eventKey="GAPLD" style={tabStyle("GAPLD")}>
                                    GPLDA
                                  </Nav.Link>
                                </Nav.Item>
                              </>
                            )}

                            {formData.gender === "Male" && (
                              <>
                                <Nav.Item as="li">
                                  <Nav.Link eventKey="GAPLD" style={tabStyle("GAPLD")}>
                                    GPLDA
                                  </Nav.Link>
                                </Nav.Item>

                                <Nav.Item as="li">
                                  <Nav.Link eventKey="Malechart" style={tabStyle("Malechart")}>
                                    Male Chart
                                  </Nav.Link>
                                </Nav.Item>
                              </>
                            )}


                            <Nav.Item as="li">
                              <Nav.Link eventKey="Reports" style={tabStyle("Reports")}>
                                Reports
                              </Nav.Link>
                            </Nav.Item>

                            <Nav.Item as="li">
                              <Nav.Link
                                eventKey="TransactionHistory"
                                style={tabStyle("TransactionHistory")}
                              >
                                Transaction History
                              </Nav.Link>
                            </Nav.Item>

                            <Nav.Item as="li">
                              <Nav.Link eventKey="Objection" style={tabStyle("Objection")}>
                                Objections
                              </Nav.Link>
                            </Nav.Item>

                            <Nav.Item>
                              <Nav.Link eventKey="followups" style={tabStyle("followups")}>Follow Up</Nav.Link>
                            </Nav.Item>

                            {tabGroupsArray.map((group) => (
                              <Nav.Item as="li" key={`nav-${group.group_id}`}>
                                <Nav.Link
                                  eventKey={`DynamicForm-${group.group_id}`}
                                  style={tabStyle(`DynamicForm-${group.group_id}`)}
                                >
                                  {group.group_name}
                                </Nav.Link>
                              </Nav.Item>
                            ))}
                          </Nav>
                        </div>
                        <Tab.Content>
                          <Tab.Pane eventKey="familytree">
                            <FamilyTree
                              patientDetails={patientDetails}
                              formData={formData || {}} // prevent undefined
                              icon3={icon3}
                              handleOpen={handleOpen}
                            />
                          </Tab.Pane>
                          <Tab.Pane eventKey="followups">
                            <div className="p-3 mt-3 ms-3">

                              <h4 className="mb-3">Follow-Up Appointment History</h4>

                              <div className="row">
                                {followUpAppointments.map((item, index) => (
                                  <div key={index} className="col-md-6 mb-3">
                                    <div className="card p-3 shadow-sm">

                                      {/* Appointment Date */}
                                      <div className="mb-2">
                                        <strong>Appointment Date:</strong>{" "}
                                        {[
                                          item?.date ? formatDate(item.date) : null,
                                          item?.time_slot,
                                          item?.appointment_status,
                                        ]
                                          .filter(Boolean)
                                          .join(" | ")}
                                      </div>

                                      {/* Doctor + Disease */}
                                      <div>
                                        {[
                                          item?.doctor_name ? `Doctor: ${item.doctor_name}` : null,
                                          item?.disease?.length
                                            ? `Disease: ${item.disease.map((d) => d.disease_name).join(", ")}`
                                            : null,
                                        ]
                                          .filter(Boolean)
                                          .join(" | ")}
                                      </div>

                                    </div>
                                  </div>
                                ))}
                              </div>

                            </div>
                          </Tab.Pane>


                          <Tab.Pane eventKey="Appointments">
                            <div className="card shadow-none">
                              <div className="card-body">
                                <div className="row">
                                  <div className="col-xl-6 col-lg-8 col-md-10">
                                    <div
                                      style={{
                                        height: "370px",
                                        overflowY: "scroll",
                                        scrollbarWidth: "none",
                                        msOverflowStyle: "none",
                                      }}
                                      id="DZ_W_TimeLine"
                                      className="widget-timeline dz-scroll height370"
                                    >
                                      <ul className="timeline">
                                        <li>
                                          <div className="timeline-badge primary"></div>
                                          <div className="timeline-panel text-muted">
                                            <Link to="#" className="text-decoration-none">
                                              <h6 className="mb-0">General Checkup</h6>
                                              <p className="fs-15 mb-0">Date: Jan 20, 2025 10:00 AM</p>
                                              <p className="fs-15 mb-0">Doctor: Dr. John Doe</p>
                                              <p className="fs-15 mb-0">
                                                <strong>Status:</strong> Pending
                                              </p>
                                            </Link>
                                            <div className="d-flex justify-content-between align-items-center mt-2">
                                              <Link
                                                to="#"
                                                onClick={openModal}
                                                className="btn btn-primary btn-xxs shadow"
                                              >
                                                Reschedule
                                              </Link>
                                              <Link
                                                to="#"
                                                className="btn btn-outline-danger btn-xxs ms-1"
                                                onClick={() => handleOnCancel("General Checkup")}
                                              >
                                                Cancel
                                              </Link>
                                            </div>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="timeline-badge info"></div>
                                          <div className="timeline-panel text-muted">
                                            <Link to="#" className="text-decoration-none">
                                              <h6 className="mb-0">Follow-up</h6>
                                              <p className="fs-15 mb-0">Date: Jan 15, 2025 02:30 PM</p>
                                              <p className="fs-15 mb-0">Doctor: Dr. Jane Smith</p>
                                              <p className="fs-15 mb-0">
                                                <strong>Status:</strong> Completed
                                              </p>
                                            </Link>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="timeline-badge danger"></div>
                                          <div className="timeline-panel text-muted">
                                            <Link to="#" className="text-decoration-none">
                                              <h6 className="mb-0">Follow-up</h6>
                                              <p className="fs-15 mb-0">Date: Jan 15, 2025 02:30 PM</p>
                                              <p className="fs-15 mb-0">Doctor: Dr. Jane Smith</p>
                                              <p className="fs-15 mb-0">
                                                <strong>Status:</strong> Completed
                                              </p>
                                            </Link>
                                          </div>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/* Modal for Calendar */}
                            <Modal show={isModalVisible} onHide={closeModal} size="lg">
                              <Modal.Header closeButton>
                                <Modal.Title>Reschedule Appointment</Modal.Title>
                              </Modal.Header>
                              <Modal.Body>
                                <FullCalendar
                                  plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                                  initialView="timeGridWeek"
                                  headerToolbar={{
                                    left: "prev,next today",
                                    center: "title",
                                    right: "dayGridMonth,timeGridWeek,timeGridDay",
                                  }}
                                  events={calendarEvents}
                                  editable={false}
                                  eventContent={renderEventContent}
                                  eventClick={handleEventClick}
                                  dateClick={handleDateClick}
                                  slotMinTime="09:00:00"
                                  slotMaxTime="21:00:00"
                                  height="auto"
                                />
                              </Modal.Body>
                              <Modal.Footer>
                                <Button variant="primary" onClick={closeModal}>
                                  Reschedule
                                </Button>
                              </Modal.Footer>
                            </Modal>
                          </Tab.Pane>

                          {/* Dynamic Form Tab Panes - Create a separate Tab.Pane for each group */}
                          {tabGroupsArray.map((group) => (
                            <Tab.Pane eventKey={`DynamicForm-${group.group_id}`} key={`pane-${group.group_id}`}>
                              {importantQuestionsLoading ? (
                                <div className="text-center my-5">
                                  <Loader size="lg" />
                                </div>
                              ) : (
                                renderDynamicFormContent(group)
                              )}
                            </Tab.Pane>
                          ))}

                          <Tab.Pane eventKey="Reports">
                            <div className="card shadow-none">
                              <div className="card-body">
                                {/* <div className="d-flex justify-content-between mb-3">
                                  <Button variant="primary" onClick={handlePreviewClick}>
                                    Add Reports
                                  </Button>
                                  
                                  <InputGroup style={{ maxWidth: "300px" }}>
                                    <FormControl
                                      placeholder="Search Reports"
                                      aria-label="Search Reports"
                                      onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                  </InputGroup>
                                </div>  */}
                                <div className="d-flex justify-content-between align-items-center mb-3">

                                  {/* Add Reports Button */}
                                   {/* LEFT SIDE (Buttons) */}
  <div className="d-flex align-items-center gap-2">

{/* Add Reports */}
<Button
  variant="outline-primary"
  size="sm"
  onClick={handlePreviewClick}
>
  Add Reports
</Button>

{/* Upload Report */}
<UploadReportButton patientId={patientId} />

</div>

                                  {/* Search Box */}
                                  <InputGroup style={{ maxWidth: "300px" }}>
                                    <FormControl
                                      placeholder="Search Reports"
                                      aria-label="Search Reports"
                                      onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                  </InputGroup>

                                </div>

                                {/* Reports Grid View */}
                                <div className="row">
                                  {filteredReports.length === 0 ? (
                                    <div className="col-12 text-center">
                                      <div className="alert alert-info" role="alert">
                                        No reports available
                                      </div>
                                    </div>
                                  ) : (
                                    filteredReports.map((report) => (
                                      <div className="col-lg-4 col-md-6 col-sm-12 mb-4" key={report.report_id}>
                                        <div
                                          className="timeline-panel bgl-dark flex-wrap border-0 p-3 rounded position-relative"
                                          onClick={() => {
                                            if (!report.report_files?.length) return;

                                            const allFiles = report.report_files
                                              .map((f) => f.url)
                                              .filter(Boolean);

                                            console.log("All files", allFiles);

                                            if (!allFiles.length) return;

                                            setPreviewGallery(allFiles);
                                            setPreviewIndex(0);
                                            setShowPreviewModal(true);
                                          }}
                                          style={{
                                            cursor: "pointer",
                                            transition: "0.2s",
                                          }}
                                          onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.03)")}
                                          onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                                        >
                                          {/* <h6 className="font-weight-bold">{report.report_title}</h6>
                                           */}
                                          <div className="d-flex justify-content-between align-items-start">
                                            <h6 className="font-weight-bold mb-0">{report.report_title}</h6>

                                            <div className="d-flex align-items-center" style={{ gap: "8px" }}>

                                              {/* Edit Icon */}
                                              <i
                                                className="las la-edit "
                                                style={{ fontSize: "20px", cursor: "pointer" }}
                                                title="Edit Report"
                                                onClick={(e) => {
                                                  e.stopPropagation(); // ✔ prevents click opening report
                                                  handleEditReport(report);
                                                }}
                                              ></i>

                                              {/* Delete Icon */}
                                              <i
                                                className="las la-trash text-danger"
                                                style={{ fontSize: "20px", cursor: "pointer" }}
                                                title="Delete Report"
                                                onClick={(e) => {
                                                  e.stopPropagation(); // ✔ prevents click opening report
                                                  handleDeleteReport(report);
                                                }}
                                              ></i>
                                            </div>
                                          </div>

                                          <p className="fs-15 mb-0">
                                            {report.report_date ? formatDate(report.report_date) : "-"}
                                          </p>

                                          {report.report_description && (
                                            <p className="fs-15 mb-0">
                                              Description: {report.report_description}
                                            </p>
                                          )}

                                          {/* Hidden File Input */}
                                          <input
                                            type="file"
                                            id={`report-file-${report.report_id}`}
                                            style={{ display: "none" }}
                                            onChange={(e) => {
                                              const file = e.target.files[0];
                                              if (file) {
                                                const validTypes = [
                                                  "image/jpeg",
                                                  "image/png",
                                                  "application/pdf",
                                                  "text/csv",
                                                ];
                                                if (!validTypes.includes(file.type)) {
                                                  showErrorAlert("Please select a valid file (JPEG, PNG, PDF, or CSV)");
                                                  return;
                                                }
                                                const fileURL = URL.createObjectURL(file);
                                                window.open(fileURL, "_blank");
                                              }
                                            }}
                                            accept=".jpg,.jpeg,.png,.pdf,.csv"
                                          />


                                        </div>

                                      </div>
                                    ))
                                  )}
                                </div>
                              </div>
                            </div>
                            {/* Reports Modal - Moved outside the mapping loop */}
                            <Modal show={isReportModalOpen} onHide={() => setIsReportModalOpen(false)}>
                              <Modal.Header closeButton>
                                <Modal.Title>Upload Report</Modal.Title>
                              </Modal.Header>
                              <Modal.Body>
                                <p>Would you like to send the report link to:</p>
                                <div className="form-check mb-2">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="reportRecipient"
                                    id="sendToPatient"
                                    value="patient"
                                    checked={selectedRecipient === "patient"}
                                    onChange={() => setSelectedRecipient("patient")}
                                  />
                                  <label className="form-check-label" htmlFor="sendToPatient">
                                    Send Link to Patient
                                  </label>
                                </div>
                                <div className="form-check mb-2">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="reportRecipient"
                                    id="sendToDoctor"
                                    value="doctor"
                                    checked={selectedRecipient === "doctor"}
                                    onChange={() => setSelectedRecipient("doctor")}
                                  />
                                  <label className="form-check-label" htmlFor="sendToDoctor">
                                    Send Link to Doctor
                                  </label>
                                </div>
                                {selectedRecipient === "doctor" && (
                                  <div className="mb-3">

                                    <label className="form-label">Select Doctor</label>

                                    <Select
                                      value={selectedDoctorValue}

                                      onChange={(option) => {
                                        if (!isDoctor) {
                                          setSelectedDoctorId(option?.value || "");
                                          setDoctorError("");
                                        }
                                      }}

                                      options={doctors.map(d => ({
                                        value: String(d.doctor_id),   // ✅ normalize type
                                        label: d.doctor_name,
                                        specialization: d.specialization || "-"
                                      }))}

                                      formatOptionLabel={formatOptionLabel}

                                      styles={{
                                        control: (base) => ({
                                          ...base,
                                          minHeight: "45px",
                                          height: "45px",
                                          borderColor: doctorError ? "#dc3545" : base.borderColor,
                                          boxShadow: doctorError
                                            ? "0 0 0 0.25rem rgba(220,53,69,.25)"
                                            : base.boxShadow,
                                          backgroundColor: isDoctor ? "#f8f9fa" : base.backgroundColor,

                                        }),
                                        menu: (base) => ({ ...base, zIndex: 9999 }),
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                      }}

                                      menuPortalTarget={document.body}
                                      placeholder="Select a doctor"
                                      classNamePrefix="select"
                                      // ✅ doctor cannot change
                                      isClearable={!isDoctor}    // ✅ doctor cannot clear
                                    />

                                    {doctorError && <div className="text-danger mt-1">{doctorError}</div>}
                                  </div>
                                )}
                                <div className="d-flex justify-content-end mt-3">
                                  <Button
                                    variant="primary"
                                    onClick={handleSubmitIn}
                                    disabled={!selectedRecipient || sendingReportLink}
                                  >
                                    {sendingReportLink ? "Sending..." : "Submit"}
                                  </Button>
                                </div>
                              </Modal.Body>
                            </Modal>
                          </Tab.Pane>
                          <Tab.Pane eventKey="noteshistory">
  <NotesHistory patientId={patientId} />
</Tab.Pane>
                          <Tab.Pane eventKey="Prescriptions">
                            <PatientPrescription></PatientPrescription>
                          </Tab.Pane>
                          <Tab.Pane eventKey="GAPLD">
                            <PatientGapld></PatientGapld>
                          </Tab.Pane>
                          <Tab.Pane eventKey="Menopause">
                            <MenopauseChart></MenopauseChart>
                          </Tab.Pane>
                          <Tab.Pane eventKey="Malechart">
                            <PatientMale></PatientMale>
                          </Tab.Pane>
                          <Tab.Pane eventKey="Panchkarma">
                            <div className="card shadow-none">
                              <div className="card-body">
                                <div
                                  style={{ height: "370px" }}
                                  id="DZ_W_TimeLine"
                                  className="widget-timeline dz-scroll height370"
                                >
                                  <ul className="timeline">
                                    <li>
                                      <div className="timeline-badge success"></div>
                                      <Link className="timeline-panel text-muted" to="/app-panchkarma">
                                        <span>
                                          Date: <strong>Jan 18, 2025</strong>
                                        </span>
                                        <h6 className="mb-0">
                                          Doctor: Dr. Mehta <strong className="text-success">Ongoing</strong>
                                        </h6>
                                      </Link>
                                    </li>
                                    <li>
                                      <div className="timeline-badge warning"></div>
                                      <Link className="timeline-panel text-muted" to="/app-panchkarma">
                                        <span>
                                          Date: <strong>Jan 18, 2025</strong>
                                        </span>
                                        <h6 className="mb-0">
                                          Doctor: Dr. Mehta <strong className="text-warning">Scheduled</strong>
                                        </h6>
                                      </Link>
                                    </li>
                                    <li>
                                      <div className="timeline-badge danger"></div>
                                      <Link className="timeline-panel text-muted" to="/app-panchkarma">
                                        <span>
                                          Date: <strong>Jan 18, 2025</strong>
                                        </span>
                                        <h6 className="mb-0">
                                          Doctor: Dr. Mehta <strong className="text-danger">Pending</strong>
                                        </h6>
                                      </Link>
                                    </li>
                                    <li>
                                      <div className="timeline-badge primary"></div>
                                      <Link className="timeline-panel text-muted" to="/app-panchkarma">
                                        <span>
                                          Date: <strong>Jan 18, 2025</strong>
                                        </span>
                                        <h6 className="mb-0">
                                          Doctor: Dr. Mehta <strong className="text-primary">Completed</strong>
                                        </h6>
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </Tab.Pane>
                          <Tab.Pane eventKey="Diseases">
                            <DiseaseHistory patientId={patientId} />
                          </Tab.Pane>
                          <Tab.Pane eventKey="Notes">
                            <PatientNotes></PatientNotes>
                          </Tab.Pane>
                          <Tab.Pane eventKey="TransactionHistory">
                            <TransactionHistory></TransactionHistory>
                          </Tab.Pane>
                          <Tab.Pane eventKey="Objection">
                            <div className="p-4 mt-3 ms-3">

                              <h4 className="mb-3">Select Objections</h4>

                              {objectionsLoading || patientObjectionsLoading ? (
                                <div className="text-center my-4">
                                  <Loader size="sm" />
                                </div>
                              ) : objectionsError ? (
                                <div className="alert alert-danger" role="alert">
                                  Error loading objections: {objectionsError}
                                </div>
                              ) : objections.length === 0 ? (
                                <div className="alert alert-info" role="alert">
                                  No objections available
                                </div>
                              ) : (
                                objections.map((objection, index) => {
                                  const objectionText = objection.objection_text || objection.text;
                                  const objectionId = objection.objection_id || objection.id;
                                  const isChecked = selectedPatientObjections.some(
                                    (obj) => (obj.objection_id || obj.id) === objectionId
                                  );

                                  return (
                                    <div className="form-check mb-2" key={objectionId || index}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id={`obj-${objectionId || index}`}
                                        checked={isChecked}
                                        disabled={updatingPatientObjections}
                                        onChange={() => handlePatientObjectionChange(objection)}
                                      />

                                      <label htmlFor={`obj-${objectionId || index}`} className="form-check-label">
                                        {objectionText}
                                        {updatingPatientObjections && isChecked && (
                                          <span className="ms-2">
                                            <span className="spinner-border spinner-border-sm" role="status">
                                              <span className="visually-hidden">Loading...</span>
                                            </span>
                                          </span>
                                        )}
                                      </label>
                                    </div>
                                  );
                                })
                              )}

                            </div>
                          </Tab.Pane>

                          <Modal show={showEditModal} onHide={() => setShowEditModal(false)} size="lg">
                            <Modal.Header closeButton>
                              <Modal.Title>Edit Report</Modal.Title>
                            </Modal.Header>

                            <Modal.Body>
                              {editReport && (
                                <EditReportForm
                                  report={editReport}
                                  onClose={() => setShowEditModal(false)}
                                  patientId={patientId}

                                />

                              )}
                            </Modal.Body>
                          </Modal>
                          {/* <Modal
                            show={showPreviewModal}
                            onHide={() => setShowPreviewModal(false)}
                            size="lg"
                            centered
                          >
                            <Modal.Header closeButton>
                              <Modal.Title>Report Preview</Modal.Title>
                            </Modal.Header>

                            <Modal.Body className="text-center">

                              {previewGallery.length > 0 && (
                                <img
                                  src={previewGallery[previewIndex].url}
                                  alt="preview"
                                  style={{ width: "100%", maxHeight: "70vh", objectFit: "contain" }}
                                />
                              )}

                              {previewGallery.length > 1 && (
                                <div className="d-flex justify-content-between mt-3">
                                  <Button
                                    variant="secondary"
                                    onClick={() =>
                                      setPreviewIndex((previewIndex - 1 + previewGallery.length) % previewGallery.length)
                                    }
                                  >
                                    ⬅ Prev
                                  </Button>

                                  <Button
                                    variant="secondary"
                                    onClick={() =>
                                      setPreviewIndex((previewIndex + 1) % previewGallery.length)
                                    }
                                  >
                                    Next ➡
                                  </Button>
                                </div>
                              )}
                            </Modal.Body>
                          </Modal> */}
                          <Modal
                            show={showPreviewModal}
                            onHide={() => setShowPreviewModal(false)}
                            size="lg"
                            centered
                          >
                            <Modal.Header closeButton>
                              <Modal.Title>Report Preview</Modal.Title>
                            </Modal.Header>

                            <Modal.Body className="text-center">
                              {previewGallery.length > 0 && previewGallery[previewIndex] && (() => {
                                const fileUrl = previewGallery[previewIndex];
                                if (!fileUrl) return <p>No preview</p>;
                                const isPDF = fileUrl.toLowerCase().endsWith(".pdf");

                                return (
                                  <>
                                    {/* Content with Arrow Buttons */}
                                    <div className="position-relative" style={{ minHeight: "350px" }}>

                                      {/* Left Arrow */}
                                      {previewGallery.length > 1 && (
                                        <button
                                          className="btn btn-outline-primary rounded-circle"
                                          onClick={() => setPreviewIndex((prev) => (prev - 1 + previewGallery.length) % previewGallery.length)}
                                          style={{
                                            position: "absolute",
                                            left: "-20px",
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            width: "45px",
                                            height: "45px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            zIndex: 10,
                                            backgroundColor: "white",
                                            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                                            border: "1px solid #dee2e6",
                                          }}
                                        >
                                          <i className="fa fa-chevron-left fa-lg"></i>
                                        </button>
                                      )}

                                      {/* Main Content */}
                                      <div style={{ padding: previewGallery.length > 1 ? "0 35px" : "0" }}>
                                        {isPDF ? (
                                          <div className="py-5">
                                            <i className="las la-file-pdf" style={{ fontSize: "100px", color: "#dc3545" }}></i>
                                            <div className="mt-4">
                                              <Button
                                                variant="danger"
                                                onClick={() => window.open(fileUrl, "_blank")}
                                                size="lg"
                                              >
                                                <i className="fa fa-file-pdf-o me-2"></i>
                                                Open PDF Document
                                              </Button>
                                            </div>
                                          </div>
                                        ) : (
                                          <img
                                            src={fileUrl}
                                            alt="Report Preview"
                                            style={{
                                              width: "100%",
                                              maxHeight: "55vh",
                                              objectFit: "contain",
                                              borderRadius: "8px",
                                              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                                            }}
                                            onClick={() => window.open(fileUrl, "_blank")} 
                                            onError={(e) => {
                                              e.target.src = "/placeholder-image.png";
                                              console.log("Image failed:", fileUrl);
                                            }}
                                          />
                                        )}
                                      </div>

                                      {/* Right Arrow */}
                                      {previewGallery.length > 1 && (
                                        <button
                                          className="btn btn-outline-primary rounded-circle"
                                          onClick={() => setPreviewIndex((prev) => (prev + 1) % previewGallery.length)}
                                          style={{
                                            position: "absolute",
                                            right: "-20px",
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            width: "45px",
                                            height: "45px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            zIndex: 10,
                                            backgroundColor: "white",
                                            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                                            border: "1px solid #dee2e6",
                                          }}
                                        >
                                          <i className="fa fa-chevron-right fa-lg"></i>
                                        </button>
                                      )}
                                    </div>

                                    {/* DOTS Navigation */}
                                    {previewGallery.length > 1 && (
                                      <div className="d-flex justify-content-center mt-4 gap-3">
                                        {previewGallery.map((_, index) => (
                                          <button
                                            key={index}
                                            onClick={() => setPreviewIndex(index)}
                                            style={{
                                              width: "10px",
                                              height: "10px",
                                              borderRadius: "50%",
                                              cursor: "pointer",
                                              backgroundColor: previewIndex === index ? "#007bff" : "#dee2e6",
                                              transition: "all 0.3s ease",
                                              border: "none",
                                              padding: "0",
                                            }}
                                            className="dot-indicator"
                                            onMouseEnter={(e) => {
                                              if (previewIndex !== index) {
                                                e.currentTarget.style.backgroundColor = "#007bff";
                                                e.currentTarget.style.opacity = "0.5";
                                              }
                                            }}
                                            onMouseLeave={(e) => {
                                              if (previewIndex !== index) {
                                                e.currentTarget.style.backgroundColor = "#dee2e6";
                                                e.currentTarget.style.opacity = "1";
                                              }
                                            }}
                                          />
                                        ))}
                                      </div>
                                    )}

                                    {/* Counter Text */}
                                    {previewGallery.length > 1 && (
                                      <div className="mt-3">
                                        <span className="badge bg-secondary">
                                          <i className="fa fa-file-image-o me-1"></i>
                                          {previewIndex + 1} / {previewGallery.length}
                                        </span>
                                      </div>
                                    )}
                                  </>
                                );
                              })()}
                            </Modal.Body>

                            <Modal.Footer>
                              <Button variant="outline-danger" onClick={() => setShowPreviewModal(false)}>
                                Close
                              </Button>
                            </Modal.Footer>
                          </Modal>

                          <Modal show={showActionModal} onHide={() => setShowActionModal(false)} centered>
                            <Modal.Header closeButton>

                            </Modal.Header>

                            <Modal.Body className="text-center">

                              <Button
                                variant="success"
                                className="me-3"
                                onClick={() => {
                                  if (patientLink) {
                                    window.open(patientLink, "_blank", "noopener,noreferrer");
                                    setShowActionModal(false);
                                  } else {
                                    alert("Patient link not available");
                                  }
                                }}
                              >
                                View Patient QR
                              </Button>

                              <Button
  variant="primary"
  onClick={handleSendPatientLink}
  disabled={sendingLink}
>
  {sendingLink ? (
    <>
      <span
        className="spinner-border spinner-border-sm me-2"
        role="status"
      ></span>
      Sending...
    </>
  ) : (
    "Send to Email"
  )}
</Button>
                            </Modal.Body>
                          </Modal>
                        </Tab.Content>
                      </Tab.Container>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default PatientsDetails
